import React from 'react';
import topTenMFAData from './formattedTopTenMFAData.json';
import topTenIPSData from './formattedTopTenIPSData.json';
// TOP TEN MFA VARS (27 funds)
const assetAllocationFund = topTenMFAData.filter( element => element.name === 'Asset Allocation');
const assetAllocationFundData = assetAllocationFund[0];
const balancedFund = topTenMFAData.filter( element => element.name === 'Balanced');
const balancedFundData = balancedFund[0];
const domesticEquityFund = topTenMFAData.filter( element => element.name === 'Domestic Equity');
const domesticEquityFundData = domesticEquityFund[0];
const emergingMarketsEquityFund = topTenMFAData.filter( element => element.name === 'Emerging Markets Equity');
const emergingMarketsEquityFundData = emergingMarketsEquityFund[0];
const equityIncomeFund = topTenMFAData.filter( element => element.name === 'Equity Income');
const equityIncomeFundData = equityIncomeFund[0];
const focusedAppreciationFund = topTenMFAData.filter( element => element.name === 'Focused Appreciation');
const focusedAppreciationFundData = focusedAppreciationFund[0];
const governmentMoneyMarketFund = topTenMFAData.filter( element => element.name === 'Government Money Market');
const governmentMoneyMarketFundData = governmentMoneyMarketFund[0];
const growthStockFund = topTenMFAData.filter( element => element.name === 'Growth Stock');
const growthStockFundData = growthStockFund[0];
const highYieldBondFund = topTenMFAData.filter( element => element.name === 'High Yield Bond');
const highYieldBondFundData = highYieldBondFund[0];
const index400StockFund = topTenMFAData.filter( element => element.name === 'Index 400 Stock');
const index400StockFundData = index400StockFund[0];
const index500StockFund = topTenMFAData.filter( element => element.name === 'Index 500 Stock');
const index500StockFundData = index500StockFund[0];
const index600StockFund = topTenMFAData.filter( element => element.name === 'Index 600 Stock');
const index600StockFundData = index600StockFund[0];
const inflationProtectionFund = topTenMFAData.filter( element => element.name === 'Inflation Protection');
const inflationProtectionFundData = inflationProtectionFund[0];
const internationalEquityFund = topTenMFAData.filter( element => element.name === 'International Equity');
const internationalEquityFundData = internationalEquityFund[0];
const internationalGrowthFund = topTenMFAData.filter( element => element.name === 'International Growth');
const internationalGrowthFundData = internationalGrowthFund[0];
const largeCapBlendFund = topTenMFAData.filter( element => element.name === 'Large Cap Blend');
const largeCapBlendFundData = largeCapBlendFund[0];
const largeCapCoreStockFund = topTenMFAData.filter( element => element.name === 'Large Cap Core Stock');
const largeCapCoreStockFundData = largeCapCoreStockFund[0];
const largeCompanyValueFund = topTenMFAData.filter( element => element.name === 'Large Company Value');
const largeCompanyValueFundData = largeCompanyValueFund[0];
const longTermUsGovernmentBondFund = topTenMFAData.filter( element => element.name === 'Long-Term U.S. Government Bond');
const longTermUsGovernmentBondFundData = longTermUsGovernmentBondFund[0];
const midCapGrowthStockFund = topTenMFAData.filter( element => element.name === 'Mid Cap Growth Stock');
const midCapGrowthStockFundData = midCapGrowthStockFund[0];
const midCapValueFund = topTenMFAData.filter( element => element.name === 'Mid Cap Value');
const midCapValueFundData = midCapValueFund[0];
const multiSectorBondFund = topTenMFAData.filter( element => element.name === 'Multi-Sector Bond');
const multiSectorBondFundData = multiSectorBondFund[0];
const researchInternationalCoreFund = topTenMFAData.filter( element => element.name === 'Research International Core');
const researchInternationalCoreFundData = researchInternationalCoreFund[0];
const selectBondFund = topTenMFAData.filter( element => element.name === 'Select Bond');
const selectBondFundData = selectBondFund[0];
const shortTermBondFund = topTenMFAData.filter( element => element.name === 'Short-Term Bond');
const shortTermBondFundData = shortTermBondFund[0];
const smallCapGrowthStockFund = topTenMFAData.filter( element => element.name === 'Small Cap Growth Stock');
const smallCapGrowthStockFundData = smallCapGrowthStockFund[0];
const smallCapValueFund = topTenMFAData.filter( element => element.name === 'Small Cap Value');
const smallCapValueFundData = smallCapValueFund[0];
// TOP TEN IPS VARS (13 funds)
// Russell Strategic Bond
const strategicBondFundProps = topTenIPSData.filter( element => element.name === 'Russell Strategic Bond');
const strategicBondFundPropsData = strategicBondFundProps[0];
const strategicBondFundVals = topTenIPSData.filter( element => element.name === 'RSB%');
const strategicBondFundValsData = strategicBondFundVals[0];
// Russell U.S. Small Cap Equity
const usSmallCapEquityFundProps = topTenIPSData.filter( element => element.name === 'Russell U.S. Small Cap Equity');
const usSmallCapEquityFundPropsData = usSmallCapEquityFundProps[0];
const usSmallCapEquityFundVals = topTenIPSData.filter( element => element.name === 'RUSCE%');
const usSmallCapEquityFundValsData = usSmallCapEquityFundVals[0];
// Neuberger Berman AMT Sustainable Equity
const neubergerBermanAmtSustainableEquityFundProps = topTenIPSData.filter( element => element.name === 'Neuberger Berman AMT Sustainable Equity');
const neubergerBermanAmtSustainableEquityFundPropsData = neubergerBermanAmtSustainableEquityFundProps[0];
const neubergerBermanAmtSustainableEquityFundVals = topTenIPSData.filter( element => element.name === 'NBASE%');
const neubergerBermanAmtSustainableEquityFundValsData = neubergerBermanAmtSustainableEquityFundVals[0];
// Russell U.S. Strategic Equity
const usStrategicEquityFundProps = topTenIPSData.filter( element => element.name === 'Russell U.S. Strategic Equity');
const usStrategicEquityFundPropsData = usStrategicEquityFundProps[0];
const usStrategicEquityFundVals = topTenIPSData.filter( element => element.name === 'RUSE%');
const usStrategicEquityFundValsData = usStrategicEquityFundVals[0];
// Credit Suisse Trust Commodity Return Strategy
const creditSuisseCommodityReturnStrategyProps = topTenIPSData.filter( element => element.name === 'Credit Suisse Trust Commodity Return Strategy');
const creditSuisseCommodityReturnStrategyPropsData = creditSuisseCommodityReturnStrategyProps[0];
const creditSuisseCommodityReturnStrategyVals = topTenIPSData.filter( element => element.name === 'CSTCRS%');
const creditSuisseCommodityReturnStrategyValsData = creditSuisseCommodityReturnStrategyVals[0];
// Fidelity VIP Contrafund
const fidelityVipContrafundPortfolioProps = topTenIPSData.filter( element => element.name === 'Fidelity VIP Contrafund');
const fidelityVipContrafundPortfolioPropsData = fidelityVipContrafundPortfolioProps[0];
const fidelityVipContrafundPortfolioVals = topTenIPSData.filter( element => element.name === 'FVC%');
const fidelityVipContrafundPortfolioValsData = fidelityVipContrafundPortfolioVals[0];
// Fidelity VIP Mid Cap
const fidelityVipMidcapPortfolioProps = topTenIPSData.filter( element => element.name === 'Fidelity VIP Mid Cap');
const fidelityVipMidcapPortfolioPropsData = fidelityVipMidcapPortfolioProps[0];
const fidelityVipMidcapPortfolioVals = topTenIPSData.filter( element => element.name === 'FVMC%');
const fidelityVipMidcapPortfolioValsData = fidelityVipMidcapPortfolioVals[0];
// Russell Global Real Estate Securities
const globalRealEstateSecuritiesFundProps = topTenIPSData.filter( element => element.name === 'Russell Global Real Estate Securities');
const globalRealEstateSecuritiesFundPropsData = globalRealEstateSecuritiesFundProps[0];
const globalRealEstateSecuritiesFundVals = topTenIPSData.filter( element => element.name === 'RGRES%');
const globalRealEstateSecuritiesFundValsData = globalRealEstateSecuritiesFundVals[0];
// Russell International Developed Markets
const internationalDevelopedMarketsFundProps = topTenIPSData.filter( element => element.name === 'Russell International Developed Markets');
const internationalDevelopedMarketsFundPropsData = internationalDevelopedMarketsFundProps[0];
const internationalDevelopedMarketsFundVals = topTenIPSData.filter( element => element.name === 'RIDM%');
const internationalDevelopedMarketsFundValsData = internationalDevelopedMarketsFundVals[0];
// Russell LifePoints Balanced Strategy
const lifepointsBalancedStrategyFundProps = topTenIPSData.filter( element => element.name === 'Russell LifePoints Balanced Strategy');
const lifepointsBalancedStrategyFundPropsData = lifepointsBalancedStrategyFundProps[0];
const lifepointsBalancedStrategyFundVals = topTenIPSData.filter( element => element.name === 'RLBS%');
const lifepointsBalancedStrategyFundValsData = lifepointsBalancedStrategyFundVals[0];
// Russell LifePoints Equity Growth Strategy
const lifepointsEquityGrowthStrategyFundProps = topTenIPSData.filter( element => element.name === 'Russell LifePoints Equity Growth Strategy');
const lifepointsEquityGrowthStrategyFundPropsData = lifepointsEquityGrowthStrategyFundProps[0];
const lifepointsEquityGrowthStrategyFundVals = topTenIPSData.filter( element => element.name === 'RLEGS%');
const lifepointsEquityGrowthStrategyFundValsData = lifepointsEquityGrowthStrategyFundVals[0];
// Russell LifePoints Growth Strategy
const lifepointsGrowthStrategyFundProps = topTenIPSData.filter( element => element.name === 'Russell LifePoints Growth Strategy');
const lifepointsGrowthStrategyFundPropsData = lifepointsGrowthStrategyFundProps[0];
const lifepointsGrowthStrategyFundVals = topTenIPSData.filter( element => element.name === 'RLGS%');
const lifepointsGrowthStrategyFundValsData = lifepointsGrowthStrategyFundVals[0];
// Russell LifePoints Moderate Strategy
const lifepointsModerateStrategyFundProps = topTenIPSData.filter( element => element.name === 'Russell LifePoints Moderate Strategy');
const lifepointsModerateStrategyFundPropsData = lifepointsModerateStrategyFundProps[0];
const lifepointsModerateStrategyFundVals = topTenIPSData.filter( element => element.name === 'RLMS%');
const lifepointsModerateStrategyFundValsData = lifepointsModerateStrategyFundVals[0];

// //////////////////////////////////////////////////////
// uncomment to display the 27 funds data in the console
// console.log(topTenMFAData);

// uncomment to display the 13 funds data in the console
// console.log(topTenIPSData);

// FUNDS DATE (update in one place for all funds)
const fundsDate = (<>3&#47;31&#47;2025</>); // Edit this date to change it for all 40 funds

const fundData = {
// ░░███╗░░██████╗░__███████╗██╗░░░██╗███╗░░██╗██████╗░░██████╗
// ░████║░░╚════██╗__██╔════╝██║░░░██║████╗░██║██╔══██╗██╔════╝
// ██╔██║░░░█████╔╝__█████╗░░██║░░░██║██╔██╗██║██║░░██║╚█████╗░
// ╚═╝██║░░░╚═══██╗__██╔══╝░░██║░░░██║██║╚████║██║░░██║░╚═══██╗
// ███████╗██████╔╝__██║░░░░░╚██████╔╝██║░╚███║██████╔╝██████╔╝
// ╚══════╝╚═════╝░__╚═╝░░░░░░╚═════╝░╚═╝░░╚══╝╚═════╝░╚═════╝░
  // 13 funds ///////////////////////////////////////////////////
  // ///////////////////////////////////////////////////////////
  strategicBondFund: {
    pageTitle: `${strategicBondFundPropsData.name} fund`,
    advisor: 'Russell Investment Management, LLC',
    fundManagers: 'BlueBay Asset Management LLP; Schroder Investment Management North America Inc.; Western Asset Management Company LLC and Western Asset Management Company Limited',
    objectiveFocus: (<>A multi&#45;manager fund that invests primarily in bonds. Bonds are fixed&#45;income securities representing debt obligations that require the issuer to repay the bondholders the principal amount borrowed and to generally pay interest. The objective is to provide current income and the preservation of capital.</>),
    assetClass: 'Bond',
    style: [
      (<>Broad Market&#47;Sector Rotation</>),
      'Bonds and other debt obligations are affected by changes in interest rates, inflation risk and the creditworthiness of their issuers. High yield bonds generally have greater price swings and higher default risks than investment grade bonds. Return of principal is not guaranteed. In contrast to owning individual bonds, there are ongoing fees and expenses associated with owning shares of bond funds.',
      'Overseas investments can pose more risks than domestic investments due to fluctuations in foreign stock markets, currency values, interest rates, government regulations and political conditions.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;1999</>),
    firstAvailableVar: (<>04&#45;30&#45;1999</>),
    firstAvailableLife: (<>06&#45;30&#45;1999</>),
    netAssets: strategicBondFundPropsData.net_assets,
    topTen: [
      {
        name: strategicBondFundPropsData.top_ten[0].name,
        percent: strategicBondFundValsData.top_ten[0].name,
      },
      {
        name: strategicBondFundPropsData.top_ten[1].name,
        percent: strategicBondFundValsData.top_ten[1].name,
      },
      {
        name: strategicBondFundPropsData.top_ten[2].name,
        percent: strategicBondFundValsData.top_ten[2].name,
      },
      {
        name: strategicBondFundPropsData.top_ten[3].name,
        percent: strategicBondFundValsData.top_ten[3].name,
      },
      {
        name: strategicBondFundPropsData.top_ten[4].name,
        percent: strategicBondFundValsData.top_ten[4].name,
      },
      {
        name: strategicBondFundPropsData.top_ten[5].name,
        percent: strategicBondFundValsData.top_ten[5].name,
      },
      {
        name: strategicBondFundPropsData.top_ten[6].name,
        percent: strategicBondFundValsData.top_ten[6].name,
      },
      {
        name: strategicBondFundPropsData.top_ten[7].name,
        percent: strategicBondFundValsData.top_ten[7].name,
      },
      {
        name: strategicBondFundPropsData.top_ten[8].name,
        percent: strategicBondFundValsData.top_ten[8].name,
      },
      {
        name: strategicBondFundPropsData.top_ten[9].name,
        percent: strategicBondFundValsData.top_ten[9].name,
      },
    ],
    topTenTotal: strategicBondFundValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: strategicBondFundPropsData.sector_weightings[0].name,
        percent: strategicBondFundValsData.sector_weightings[0].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[1].name,
        percent: strategicBondFundValsData.sector_weightings[1].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[2].name,
        percent: strategicBondFundValsData.sector_weightings[2].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[3].name,
        percent: strategicBondFundValsData.sector_weightings[3].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[4].name,
        percent: strategicBondFundValsData.sector_weightings[4].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[5].name,
        percent: strategicBondFundValsData.sector_weightings[5].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[6].name,
        percent: strategicBondFundValsData.sector_weightings[6].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[7].name,
        percent: strategicBondFundValsData.sector_weightings[7].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[8].name,
        percent: strategicBondFundValsData.sector_weightings[8].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[9].name,
        percent: strategicBondFundValsData.sector_weightings[9].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[10].name,
        percent: strategicBondFundValsData.sector_weightings[10].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[11].name,
        percent: strategicBondFundValsData.sector_weightings[11].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[12].name,
        percent: strategicBondFundValsData.sector_weightings[12].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[13].name,
        percent: strategicBondFundValsData.sector_weightings[13].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[14].name,
        percent: strategicBondFundValsData.sector_weightings[14].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[15].name,
        percent: strategicBondFundValsData.sector_weightings[15].name,
      },
      {
        name: strategicBondFundPropsData.sector_weightings[16].name,
        percent: strategicBondFundValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // ///////////////////////////////////////////////////////////
  usSmallCapEquityFund: {
    pageTitle: `${usSmallCapEquityFundPropsData.name} fund`,
    advisor: 'Russell Investment Management, LLC',
    fundManagers: (<>Ancora Advisors, LLC; BAMCO, Inc.; Boston Partners Global Investors, Inc.; Calamos Advisors LLC; Copeland Capital Management, LLC; DePrince, Race &#38; Zollo, Inc.; Jacobs Levy Equity Management, Inc.; Penn Capital Management, LLC; Ranger Investment Management, L.P.</>),
    objectiveFocus: (<>A multi&#45;manager fund that invest primarily in equity securities of small capitalization companies, most of which are U.S. based. The objective is to provide long&#45;term capital growth.</>),
    assetClass: (<>Small&#45;Cap Stocks&#47;Mid&#45;Cap Stocks</>),
    style: [
      (<>Value, Growth and Market&#45;Oriented</>),
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks.',
      'Investing in medium company stocks involves a greater degree of risk than investing in large company stocks.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;1999</>),
    firstAvailableVar: (<>04&#45;30&#45;1999</>),
    firstAvailableLife: (<>06&#45;30&#45;1999</>),
    netAssets: usSmallCapEquityFundPropsData.net_assets,
    topTen: [
      {
        name: usSmallCapEquityFundPropsData.top_ten[0].name,
        percent: usSmallCapEquityFundValsData.top_ten[0].name,
      },
      {
        name: usSmallCapEquityFundPropsData.top_ten[1].name,
        percent: usSmallCapEquityFundValsData.top_ten[1].name,
      },
      {
        name: usSmallCapEquityFundPropsData.top_ten[2].name,
        percent: usSmallCapEquityFundValsData.top_ten[2].name,
      },
      {
        name: usSmallCapEquityFundPropsData.top_ten[3].name,
        percent: usSmallCapEquityFundValsData.top_ten[3].name,
      },
      {
        name: usSmallCapEquityFundPropsData.top_ten[4].name,
        percent: usSmallCapEquityFundValsData.top_ten[4].name,
      },
      {
        name: usSmallCapEquityFundPropsData.top_ten[5].name,
        percent: usSmallCapEquityFundValsData.top_ten[5].name,
      },
      {
        name: usSmallCapEquityFundPropsData.top_ten[6].name,
        percent: usSmallCapEquityFundValsData.top_ten[6].name,
      },
      {
        name: usSmallCapEquityFundPropsData.top_ten[7].name,
        percent: usSmallCapEquityFundValsData.top_ten[7].name,
      },
      {
        name: usSmallCapEquityFundPropsData.top_ten[8].name,
        percent: usSmallCapEquityFundValsData.top_ten[8].name,
      },
      {
        name: usSmallCapEquityFundPropsData.top_ten[9].name,
        percent: usSmallCapEquityFundValsData.top_ten[9].name,
      },
    ],
    topTenTotal: usSmallCapEquityFundValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[0].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[0].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[1].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[1].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[2].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[2].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[3].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[3].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[4].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[4].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[5].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[5].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[6].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[6].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[7].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[7].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[8].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[8].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[9].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[9].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[10].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[10].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[11].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[11].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[12].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[12].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[13].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[13].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[14].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[14].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[15].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[15].name,
      },
      {
        name: usSmallCapEquityFundPropsData.sector_weightings[16].name,
        percent: usSmallCapEquityFundValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // ///////////////////////////////////////////////////////////
  usStrategicEquityFund: {
    pageTitle: `${usStrategicEquityFundPropsData.name} fund`,
    advisor: 'Russell Investment Management, LLC',
    fundManagers: 'Brandywine Global Investment Management, LLC; HS Management Partners, LLC; Jackson Square Partners, LLC; Jacobs Levy Equity Management, Inc.',
    objectiveFocus: (<>A multi&#45;manager fund that invests primarily in equity securities of medium and large capitalization U.S. companies. The objective is to provide long&#45;term capital growth.</>),
    assetClass: (<>Mid&#45;Cap Stocks&#47;Large&#45;Cap Stocks</>),
    style: [
      'Blend',
      'No investment strategy can guarantee a profit or protect against a loss.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;1999</>),
    firstAvailableVar: (<>04&#45;30&#45;1999</>),
    firstAvailableLife: (<>06&#45;30&#45;1999</>),
    netAssets: usStrategicEquityFundPropsData.net_assets,
    topTen: [
      {
        name: usStrategicEquityFundPropsData.top_ten[0].name,
        percent: usStrategicEquityFundValsData.top_ten[0].name,
      },
      {
        name: usStrategicEquityFundPropsData.top_ten[1].name,
        percent: usStrategicEquityFundValsData.top_ten[1].name,
      },
      {
        name: usStrategicEquityFundPropsData.top_ten[2].name,
        percent: usStrategicEquityFundValsData.top_ten[2].name,
      },
      {
        name: usStrategicEquityFundPropsData.top_ten[3].name,
        percent: usStrategicEquityFundValsData.top_ten[3].name,
      },
      {
        name: usStrategicEquityFundPropsData.top_ten[4].name,
        percent: usStrategicEquityFundValsData.top_ten[4].name,
      },
      {
        name: usStrategicEquityFundPropsData.top_ten[5].name,
        percent: usStrategicEquityFundValsData.top_ten[5].name,
      },
      {
        name: usStrategicEquityFundPropsData.top_ten[6].name,
        percent: usStrategicEquityFundValsData.top_ten[6].name,
      },
      {
        name: usStrategicEquityFundPropsData.top_ten[7].name,
        percent: usStrategicEquityFundValsData.top_ten[7].name,
      },
      {
        name: usStrategicEquityFundPropsData.top_ten[8].name,
        percent: usStrategicEquityFundValsData.top_ten[8].name,
      },
      {
        name: usStrategicEquityFundPropsData.top_ten[9].name,
        percent: usStrategicEquityFundValsData.top_ten[9].name,
      },
    ],
    topTenTotal: usStrategicEquityFundValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: usStrategicEquityFundPropsData.sector_weightings[0].name,
        percent: usStrategicEquityFundValsData.sector_weightings[0].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[1].name,
        percent: usStrategicEquityFundValsData.sector_weightings[1].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[2].name,
        percent: usStrategicEquityFundValsData.sector_weightings[2].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[3].name,
        percent: usStrategicEquityFundValsData.sector_weightings[3].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[4].name,
        percent: usStrategicEquityFundValsData.sector_weightings[4].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[5].name,
        percent: usStrategicEquityFundValsData.sector_weightings[5].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[6].name,
        percent: usStrategicEquityFundValsData.sector_weightings[6].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[7].name,
        percent: usStrategicEquityFundValsData.sector_weightings[7].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[8].name,
        percent: usStrategicEquityFundValsData.sector_weightings[8].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[9].name,
        percent: usStrategicEquityFundValsData.sector_weightings[9].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[10].name,
        percent: usStrategicEquityFundValsData.sector_weightings[10].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[11].name,
        percent: usStrategicEquityFundValsData.sector_weightings[11].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[12].name,
        percent: usStrategicEquityFundValsData.sector_weightings[12].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[13].name,
        percent: usStrategicEquityFundValsData.sector_weightings[13].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[14].name,
        percent: usStrategicEquityFundValsData.sector_weightings[14].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[15].name,
        percent: usStrategicEquityFundValsData.sector_weightings[15].name,
      },
      {
        name: usStrategicEquityFundPropsData.sector_weightings[16].name,
        percent: usStrategicEquityFundValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // /////////////////////////////////////////////////////////////////////
  creditSuisseCommodityReturnStrategy: {
    pageTitle: `${creditSuisseCommodityReturnStrategyPropsData.name} fund`,
    advisor: 'UBS Asset Management (Americas) LLC',
    objectiveFocus: (<>The fund is designed to achieve positive total return relative to the performance of the Bloomberg Commodity Index Total Return (BCOM Index). Invests in commodity&#45;linked derivative instruments, backed by a portfolio of short&#45;maturity investment&#45;grade fixed income securities normally having an average duration of one year or less.</>),
    assetClass: 'Commodities',
    style: [
      (<>Exposure to the commodities markets may subject the Credit Suisse Trust Commodity Return Strategy Portfolio to greater volatility than investments in securities, particularly if the investments involve leverage. The value of commodity&#45;linked derivative instruments may be affected by changes in the overall market movements, commodity index volatility, changes in interest rates or sectors affecting a particular industry or commodity and international economic, political and regulatory developments. The use of leveraged commodity&#45;linked derivatives creates an opportunity for increased return, but also creates the possibility for a greater loss.</>),
      'Changes in the value of a hedging instrument may not match those of the investment being hedged.',
      'The Bloomberg Commodity Index Total Return is composed of futures contracts on 23 physical commodities. Investors cannot invest directly in an index.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>11&#45;15&#45;2013</>),
    firstAvailableVar: (<>11&#45;15&#45;2013</>),
    firstAvailableLife: (<>11&#45;15&#45;2013</>),
    netAssets: creditSuisseCommodityReturnStrategyPropsData.net_assets,
    topTen: [
      {
        name: creditSuisseCommodityReturnStrategyPropsData.top_ten[0].name,
        percent: creditSuisseCommodityReturnStrategyValsData.top_ten[0].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.top_ten[1].name,
        percent: creditSuisseCommodityReturnStrategyValsData.top_ten[1].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.top_ten[2].name,
        percent: creditSuisseCommodityReturnStrategyValsData.top_ten[2].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.top_ten[3].name,
        percent: creditSuisseCommodityReturnStrategyValsData.top_ten[3].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.top_ten[4].name,
        percent: creditSuisseCommodityReturnStrategyValsData.top_ten[4].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.top_ten[5].name,
        percent: creditSuisseCommodityReturnStrategyValsData.top_ten[5].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.top_ten[6].name,
        percent: creditSuisseCommodityReturnStrategyValsData.top_ten[6].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.top_ten[7].name,
        percent: creditSuisseCommodityReturnStrategyValsData.top_ten[7].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.top_ten[8].name,
        percent: creditSuisseCommodityReturnStrategyValsData.top_ten[8].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.top_ten[9].name,
        percent: creditSuisseCommodityReturnStrategyValsData.top_ten[9].name,
      },
    ],
    topTenTotal: creditSuisseCommodityReturnStrategyValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[0].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[0].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[1].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[1].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[2].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[2].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[3].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[3].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[4].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[4].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[5].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[5].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[6].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[6].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[7].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[7].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[8].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[8].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[9].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[9].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[10].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[10].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[11].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[11].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[12].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[12].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[13].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[13].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[14].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[14].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[15].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[15].name,
      },
      {
        name: creditSuisseCommodityReturnStrategyPropsData.sector_weightings[16].name,
        percent: creditSuisseCommodityReturnStrategyValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // ///////////////////////////////////////////////////////////////////////////
  fidelityVipContrafundPortfolio: {
    pageTitle: <>{fidelityVipContrafundPortfolioPropsData.name}&#8480; fund</>,
    advisor: (<>Fidelity Management &#38; Research Company LLC</>),
    objectiveFocus: (<>Normally invests primarily in common stocks. Seeks long&#45;term capital appreciation.</>),
    assetClass: (<>Large&#45;Cap Stocks</>),
    style: [
      'Blend',
      'Stocks of smaller or newer companies, such as those held in this Fund, are more likely to realize more substantial growth as well as suffer more significant losses than larger or more established issuers. Investments in such companies can be both more volatile and more speculative.',
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks. Their securities may also trade less frequently and in lower volumes, making market prices more volatile.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: fidelityVipContrafundPortfolioPropsData.net_assets,
    topTen: [
      {
        name: fidelityVipContrafundPortfolioPropsData.top_ten[0].name,
        percent: fidelityVipContrafundPortfolioValsData.top_ten[0].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.top_ten[1].name,
        percent: fidelityVipContrafundPortfolioValsData.top_ten[1].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.top_ten[2].name,
        percent: fidelityVipContrafundPortfolioValsData.top_ten[2].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.top_ten[3].name,
        percent: fidelityVipContrafundPortfolioValsData.top_ten[3].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.top_ten[4].name,
        percent: fidelityVipContrafundPortfolioValsData.top_ten[4].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.top_ten[5].name,
        percent: fidelityVipContrafundPortfolioValsData.top_ten[5].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.top_ten[6].name,
        percent: fidelityVipContrafundPortfolioValsData.top_ten[6].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.top_ten[7].name,
        percent: fidelityVipContrafundPortfolioValsData.top_ten[7].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.top_ten[8].name,
        percent: fidelityVipContrafundPortfolioValsData.top_ten[8].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.top_ten[9].name,
        percent: fidelityVipContrafundPortfolioValsData.top_ten[9].name,
      },
    ],
    topTenTotal: fidelityVipContrafundPortfolioValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[0].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[0].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[1].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[1].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[2].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[2].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[3].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[3].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[4].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[4].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[5].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[5].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[6].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[6].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[7].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[7].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[8].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[8].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[9].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[9].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[10].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[10].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[11].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[11].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[12].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[12].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[13].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[13].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[14].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[14].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[15].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[15].name,
      },
      {
        name: fidelityVipContrafundPortfolioPropsData.sector_weightings[16].name,
        percent: fidelityVipContrafundPortfolioValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // //////////////////////////////////////////////////////////////////////////////////
  fidelityVipMidcapPortfolio: {
    pageTitle: `${fidelityVipMidcapPortfolioPropsData.name} fund`,
    advisor: (<>Fidelity Management &#38; Research Company LLC</>),
    objectiveFocus: (<>Primarily securities of domestic or foreign companies with medium market capitalizations. May invest in either growth stocks or value stocks. The objective is long&#45;term growth of capital.</>),
    assetClass: (<>Mid&#45;Cap Stocks</>),
    style: [
      'Blend',
      'Overseas investments can pose more risks than domestic investments. Unit values are subject to fluctuations in foreign stock markets, currency values, interest rates, government regulations and political conditions.',
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks.',
      'Investing in medium company stocks involves a greater degree of risk than investing in large company stocks.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>12&#45;28&#45;1998</>),
    firstAvailableVar: (<>05&#45;01&#45;2003</>),
    firstAvailableLife: (<>05&#45;01&#45;2003</>),
    netAssets: fidelityVipMidcapPortfolioPropsData.net_assets,
    topTen: [
      {
        name: fidelityVipMidcapPortfolioPropsData.top_ten[0].name,
        percent: fidelityVipMidcapPortfolioValsData.top_ten[0].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.top_ten[1].name,
        percent: fidelityVipMidcapPortfolioValsData.top_ten[1].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.top_ten[2].name,
        percent: fidelityVipMidcapPortfolioValsData.top_ten[2].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.top_ten[3].name,
        percent: fidelityVipMidcapPortfolioValsData.top_ten[3].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.top_ten[4].name,
        percent: fidelityVipMidcapPortfolioValsData.top_ten[4].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.top_ten[5].name,
        percent: fidelityVipMidcapPortfolioValsData.top_ten[5].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.top_ten[6].name,
        percent: fidelityVipMidcapPortfolioValsData.top_ten[6].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.top_ten[7].name,
        percent: fidelityVipMidcapPortfolioValsData.top_ten[7].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.top_ten[8].name,
        percent: fidelityVipMidcapPortfolioValsData.top_ten[8].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.top_ten[9].name,
        percent: fidelityVipMidcapPortfolioValsData.top_ten[9].name,
      },
    ],
    topTenTotal: fidelityVipMidcapPortfolioValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[0].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[0].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[1].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[1].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[2].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[2].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[3].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[3].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[4].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[4].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[5].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[5].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[6].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[6].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[7].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[7].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[8].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[8].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[9].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[9].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[10].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[10].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[11].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[11].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[12].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[12].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[13].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[13].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[14].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[14].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[15].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[15].name,
      },
      {
        name: fidelityVipMidcapPortfolioPropsData.sector_weightings[16].name,
        percent: fidelityVipMidcapPortfolioValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // ////////////////////////////////////////////////////////////////////////////////////////
  globalRealEstateSecuritiesFund: {
    pageTitle: `${globalRealEstateSecuritiesFundPropsData.name} fund`,
    advisor: 'Russell Investment Management, LLC',
    fundManagers: (<>Cohen &#38; Steers Capital Management, Inc., Cohen &#38; Steers UK Limited and Cohen &#38; Steers Asia Limited; RREEF America L.L.C., DWS Investments Australia Limited and DWS Alternatives Global Limited, operating under the brand name DWS</>),
    objectiveFocus: (<>The fund seeks to provide current income and long term capital growth. The Global Real Estate Securities Fund (Russell Investments) is a multi&#45;manager fund that seeks to achieve its objective by concentrating its investments in equity securities of real estate companies (real estate securities) located in a number of countries around the world, including the U.S., in a globally diversified manner. The Fund considers a company to be a real estate company if at least 50&#37; of its assets, gross income or net profits are attributable to the ownership, construction, development, financing, management or sale of residential, commercial or industrial real estate.</>),
    assetClass: 'Real Estate',
    style: [
      (<>Value, Growth and Market&#45;Oriented</>),
      'Equity Real Estate Investment Trusts (REITs) may be affected by changes in the value of the underlying property owned by the trust, while mortgage REITs may be affected by the quality of any credit extended. This fund is subject to some of the risks associated with direct ownership of real estate, including market value declines, risks related to general and local economic conditions and increases in interest rates. This fund, however, does not own real estate directly.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;1999</>),
    firstAvailableVar: (<>04&#45;30&#45;1999</>),
    firstAvailableLife: (<>06&#45;30&#45;1999</>),
    netAssets: globalRealEstateSecuritiesFundPropsData.net_assets,
    topTen: [
      {
        name: globalRealEstateSecuritiesFundPropsData.top_ten[0].name,
        percent: globalRealEstateSecuritiesFundValsData.top_ten[0].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.top_ten[1].name,
        percent: globalRealEstateSecuritiesFundValsData.top_ten[1].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.top_ten[2].name,
        percent: globalRealEstateSecuritiesFundValsData.top_ten[2].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.top_ten[3].name,
        percent: globalRealEstateSecuritiesFundValsData.top_ten[3].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.top_ten[4].name,
        percent: globalRealEstateSecuritiesFundValsData.top_ten[4].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.top_ten[5].name,
        percent: globalRealEstateSecuritiesFundValsData.top_ten[5].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.top_ten[6].name,
        percent: globalRealEstateSecuritiesFundValsData.top_ten[6].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.top_ten[7].name,
        percent: globalRealEstateSecuritiesFundValsData.top_ten[7].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.top_ten[8].name,
        percent: globalRealEstateSecuritiesFundValsData.top_ten[8].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.top_ten[9].name,
        percent: globalRealEstateSecuritiesFundValsData.top_ten[9].name,
      },
    ],
    topTenTotal: globalRealEstateSecuritiesFundValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[0].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[0].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[1].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[1].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[2].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[2].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[3].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[3].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[4].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[4].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[5].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[5].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[6].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[6].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[7].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[7].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[8].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[8].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[9].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[9].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[10].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[10].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[11].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[11].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[12].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[12].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[13].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[13].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[14].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[14].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[15].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[15].name,
      },
      {
        name: globalRealEstateSecuritiesFundPropsData.sector_weightings[16].name,
        percent: globalRealEstateSecuritiesFundValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // ////////////////////////////////////////////////////////////////////////////////////////
  internationalDevelopedMarketsFund: {
    pageTitle: `${internationalDevelopedMarketsFundPropsData.name} fund`,
    advisor: 'Russell Investment Management, LLC',
    fundManagers: 'Intermede Investment Partners Limited and Intermede Global Partners Inc.; Pzena Investment Management LLC; J.P. Morgan Investment Management, Inc.',
    objectiveFocus: (<>A multi&#45;manager fund that invest primarily in equity securities issued by companies located in countries (other than the U.S.) with developed markets or that are economically tied to such countries. The objective is to provide long&#45;term capital growth.</>),
    assetClass: 'International Stocks',
    style: [
      (<>Value, Growth and Market&#45;Oriented</>),
      'Overseas investments can pose more risks than domestic investments. Unit values are subject to fluctuations in foreign stock markets, currency values, interest rates, government regulations and political conditions.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;1999</>),
    firstAvailableVar: (<>04&#45;30&#45;1999</>),
    firstAvailableLife: (<>04&#45;30&#45;1999</>),
    netAssets: internationalDevelopedMarketsFundPropsData.net_assets,
    topTen: [
      {
        name: internationalDevelopedMarketsFundPropsData.top_ten[0].name,
        percent: internationalDevelopedMarketsFundValsData.top_ten[0].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.top_ten[1].name,
        percent: internationalDevelopedMarketsFundValsData.top_ten[1].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.top_ten[2].name,
        percent: internationalDevelopedMarketsFundValsData.top_ten[2].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.top_ten[3].name,
        percent: internationalDevelopedMarketsFundValsData.top_ten[3].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.top_ten[4].name,
        percent: internationalDevelopedMarketsFundValsData.top_ten[4].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.top_ten[5].name,
        percent: internationalDevelopedMarketsFundValsData.top_ten[5].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.top_ten[6].name,
        percent: internationalDevelopedMarketsFundValsData.top_ten[6].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.top_ten[7].name,
        percent: internationalDevelopedMarketsFundValsData.top_ten[7].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.top_ten[8].name,
        percent: internationalDevelopedMarketsFundValsData.top_ten[8].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.top_ten[9].name,
        percent: internationalDevelopedMarketsFundValsData.top_ten[9].name,
      },
    ],
    topTenTotal: internationalDevelopedMarketsFundValsData.top_ten_total,
    sectorWeightingsTitle: 'Country Diversification',
    sectorWeightings: [
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[0].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[0].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[1].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[1].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[2].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[2].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[3].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[3].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[4].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[4].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[5].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[5].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[6].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[6].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[7].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[7].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[8].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[8].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[9].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[9].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[10].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[10].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[11].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[11].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[12].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[12].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[13].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[13].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[14].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[14].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[15].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[15].name,
      },
      {
        name: internationalDevelopedMarketsFundPropsData.sector_weightings[16].name,
        percent: internationalDevelopedMarketsFundValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // ////////////////////////////////////////////////////////////
  lifepointsBalancedStrategyFund: {
    pageTitle: `${lifepointsBalancedStrategyFundPropsData.name} fund`,
    advisor: 'Russell Investment Management, LLC',
    objectiveFocus: (<>A broadly diversified fund of funds, investing in a combination of multi&#45;manager underlying funds consisting of approximately 58&#37; equity, 30&#37; fixed income, 8&#37; multi&#45;asset, and 4&#37; alternative. The objective is to provide above&#45;average long&#45;term capital appreciation and a moderate level of current income.</>),
    style: [
      (<>Value, Growth and Market&#45;Oriented</>),
      (<>Russell Investment Group, a Washington USA corporation, operates through subsidiaries worldwide.</>),
      (<>Each of the Divisions identified as a LifePoints Variable Target Portfolio Series Fund (LifePoints Fund) is a fund of funds and diversified its assets by investing, at present, in other mutual funds (the &#34;Underlying Fund&#34;). Each LifePoints fund seeks to achieve a specific investment objective by investing in different combinations of the Underlying Funds.</>),
      (<>LifePoints&#174; and the Russell Investments logo are registered trademarks and service marks of Russell Investment Group.</>),
      (<>No investment strategy can guarantee a profit or protect against a loss.</>),
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: lifepointsBalancedStrategyFundPropsData.net_assets,
    topTen: [
      {
        name: lifepointsBalancedStrategyFundPropsData.top_ten[0].name,
        percent: lifepointsBalancedStrategyFundValsData.top_ten[0].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.top_ten[1].name,
        percent: lifepointsBalancedStrategyFundValsData.top_ten[1].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.top_ten[2].name,
        percent: lifepointsBalancedStrategyFundValsData.top_ten[2].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.top_ten[3].name,
        percent: lifepointsBalancedStrategyFundValsData.top_ten[3].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.top_ten[4].name,
        percent: lifepointsBalancedStrategyFundValsData.top_ten[4].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.top_ten[5].name,
        percent: lifepointsBalancedStrategyFundValsData.top_ten[5].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.top_ten[6].name,
        percent: lifepointsBalancedStrategyFundValsData.top_ten[6].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.top_ten[7].name,
        percent: lifepointsBalancedStrategyFundValsData.top_ten[7].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.top_ten[8].name,
        percent: lifepointsBalancedStrategyFundValsData.top_ten[8].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.top_ten[9].name,
        percent: lifepointsBalancedStrategyFundValsData.top_ten[9].name,
      },
    ],
    topTenTotal: lifepointsBalancedStrategyFundValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[0].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[0].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[1].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[1].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[2].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[2].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[3].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[3].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[4].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[4].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[5].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[5].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[6].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[6].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[7].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[7].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[8].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[8].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[9].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[9].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[10].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[10].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[11].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[11].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[12].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[12].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[13].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[13].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[14].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[14].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[15].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[15].name,
      },
      {
        name: lifepointsBalancedStrategyFundPropsData.sector_weightings[16].name,
        percent: lifepointsBalancedStrategyFundValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // //////////////////////////////////////////////////////////////////////
  lifepointsEquityGrowthStrategyFund: {
    pageTitle: `${lifepointsEquityGrowthStrategyFundPropsData.name} fund`,
    advisor: 'Russell Investment Management, LLC',
    objectiveFocus: (<>A broadly diversified fund of funds, investing in a combination of multi&#45;manager underlying funds consisting of approximately 85&#37; equity, 0&#37; fixed income, 10&#37; multi&#45;asset, and 5&#37; alternative. The objective is to provide high long&#45;term capital appreciation.</>),
    style: [
      (<>Value, Growth and Market&#45;Oriented</>),
      (<>Russell Investment Group, a Washington USA corporation, operates through subsidiaries worldwide.</>),
      (<>Each of the Divisions identified as a LifePoints Variable Target Portfolio Series Fund (LifePoints Fund) is a fund of funds and diversified its assets by investing, at present, in other mutual funds (the &#34;Underlying Fund&#34;). Each LifePoints fund seeks to achieve a specific investment objective by investing in different combinations of the Underlying Funds.</>),
      (<>LifePoints&#174; and the Russell Investments logo are registered trademarks and service marks of Russell Investment Group.</>),
      (<>No investment strategy can guarantee a profit or protect against a loss.</>),
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: lifepointsEquityGrowthStrategyFundPropsData.net_assets,
    topTen: [
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.top_ten[0].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.top_ten[0].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.top_ten[1].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.top_ten[1].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.top_ten[2].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.top_ten[2].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.top_ten[3].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.top_ten[3].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.top_ten[4].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.top_ten[4].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.top_ten[5].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.top_ten[5].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.top_ten[6].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.top_ten[6].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.top_ten[7].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.top_ten[7].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.top_ten[8].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.top_ten[8].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.top_ten[9].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.top_ten[9].name,
      },
    ],
    topTenTotal: lifepointsEquityGrowthStrategyFundValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[0].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[0].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[1].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[1].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[2].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[2].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[3].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[3].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[4].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[4].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[5].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[5].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[6].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[6].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[7].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[7].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[8].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[8].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[9].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[9].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[10].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[10].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[11].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[11].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[12].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[12].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[13].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[13].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[14].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[14].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[15].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[15].name,
      },
      {
        name: lifepointsEquityGrowthStrategyFundPropsData.sector_weightings[16].name,
        percent: lifepointsEquityGrowthStrategyFundValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // ////////////////////////////////////////////////////////////////
  lifepointsGrowthStrategyFund: {
    pageTitle: `${lifepointsGrowthStrategyFundPropsData.name} fund`,
    advisor: 'Russell Investment Management, LLC',
    objectiveFocus: (<>A broadly diversified fund of funds, investing in a combination of underlying funds consisting of approximately 74&#37; equity, 11&#37; fixed income, 10&#37; multi&#45;asset, and 5&#37; alternative. The objective is to provide high long&#45;term capital appreciation, and as a secondary objective, current income.</>),
    style: [
      (<>Value, Growth and Market&#45;Oriented</>),
      (<>Russell Investment Group, a Washington USA corporation, operates through subsidiaries worldwide.</>),
      (<>Each of the Divisions identified as a LifePoints Variable Target Portfolio Series Fund (LifePoints Fund) is a fund of funds and diversified its assets by investing, at present, in other mutual funds (the &#34;Underlying Fund&#34;). Each LifePoints fund seeks to achieve a specific investment objective by investing in different combinations of the Underlying Funds.</>),
      (<>LifePoints&#174; and the Russell Investments logo are registered trademarks and service marks of Russell Investment Group.</>),
      (<>No investment strategy can guarantee a profit or protect against a loss.</>),
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: lifepointsGrowthStrategyFundPropsData.net_assets,
    topTen: [
      {
        name: lifepointsGrowthStrategyFundPropsData.top_ten[0].name,
        percent: lifepointsGrowthStrategyFundValsData.top_ten[0].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.top_ten[1].name,
        percent: lifepointsGrowthStrategyFundValsData.top_ten[1].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.top_ten[2].name,
        percent: lifepointsGrowthStrategyFundValsData.top_ten[2].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.top_ten[3].name,
        percent: lifepointsGrowthStrategyFundValsData.top_ten[3].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.top_ten[4].name,
        percent: lifepointsGrowthStrategyFundValsData.top_ten[4].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.top_ten[5].name,
        percent: lifepointsGrowthStrategyFundValsData.top_ten[5].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.top_ten[6].name,
        percent: lifepointsGrowthStrategyFundValsData.top_ten[6].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.top_ten[7].name,
        percent: lifepointsGrowthStrategyFundValsData.top_ten[7].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.top_ten[8].name,
        percent: lifepointsGrowthStrategyFundValsData.top_ten[8].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.top_ten[9].name,
        percent: lifepointsGrowthStrategyFundValsData.top_ten[9].name,
      },
    ],
    topTenTotal: lifepointsGrowthStrategyFundValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[0].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[0].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[1].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[1].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[2].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[2].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[3].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[3].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[4].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[4].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[5].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[5].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[6].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[6].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[7].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[7].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[8].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[8].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[9].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[9].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[10].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[10].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[11].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[11].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[12].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[12].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[13].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[13].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[14].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[14].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[15].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[15].name,
      },
      {
        name: lifepointsGrowthStrategyFundPropsData.sector_weightings[16].name,
        percent: lifepointsGrowthStrategyFundValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // ////////////////////////////////////////////////////////////////
  lifepointsModerateStrategyFund: {
    pageTitle: `${lifepointsModerateStrategyFundPropsData.name} fund`,
    advisor: 'Russell Investment Management, LLC',
    objectiveFocus: (<>A broadly diversified fund of funds, investing in a combination of multi&#45;manager underlying funds consisting of approximately 38&#37; equity, 49&#37; fixed income, 10&#37; multi&#45;asset, and 3&#37; alternative. The objective is to provide current income and moderate long&#45;term capital appreciation.</>),
    style: [
      (<>Value, Growth and Market&#45;Oriented</>),
      (<>Russell Investment Group, a Washington USA corporation, operates through subsidiaries worldwide.</>),
      (<>Each of the Divisions identified as a LifePoints Variable Target Portfolio Series Fund (LifePoints Fund) is a fund of funds and diversified its assets by investing, at present, in other mutual funds (the &#34;Underlying Fund&#34;). Each LifePoints fund seeks to achieve a specific investment objective by investing in different combinations of the Underlying Funds.</>),
      (<>LifePoints&#174; and the Russell Investments logo are registered trademarks and service marks of Russell Investment Group.</>),
      (<>No investment strategy can guarantee a profit or protect against a loss.</>),
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: lifepointsModerateStrategyFundPropsData.net_assets,
    topTen: [
      {
        name: lifepointsModerateStrategyFundPropsData.top_ten[0].name,
        percent: lifepointsModerateStrategyFundValsData.top_ten[0].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.top_ten[1].name,
        percent: lifepointsModerateStrategyFundValsData.top_ten[1].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.top_ten[2].name,
        percent: lifepointsModerateStrategyFundValsData.top_ten[2].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.top_ten[3].name,
        percent: lifepointsModerateStrategyFundValsData.top_ten[3].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.top_ten[4].name,
        percent: lifepointsModerateStrategyFundValsData.top_ten[4].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.top_ten[5].name,
        percent: lifepointsModerateStrategyFundValsData.top_ten[5].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.top_ten[6].name,
        percent: lifepointsModerateStrategyFundValsData.top_ten[6].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.top_ten[7].name,
        percent: lifepointsModerateStrategyFundValsData.top_ten[7].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.top_ten[8].name,
        percent: lifepointsModerateStrategyFundValsData.top_ten[8].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.top_ten[9].name,
        percent: lifepointsModerateStrategyFundValsData.top_ten[9].name,
      },
    ],
    topTenTotal: lifepointsModerateStrategyFundValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[0].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[0].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[1].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[1].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[2].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[2].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[3].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[3].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[4].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[4].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[5].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[5].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[6].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[6].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[7].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[7].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[8].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[8].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[9].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[9].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[10].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[10].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[11].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[11].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[12].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[12].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[13].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[13].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[14].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[14].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[15].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[15].name,
      },
      {
        name: lifepointsModerateStrategyFundPropsData.sector_weightings[16].name,
        percent: lifepointsModerateStrategyFundValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // ///////////////////////////////////////////////////////////
  neubergerBermanAmtSustainableEquityFund: {
    pageTitle: `${neubergerBermanAmtSustainableEquityFundPropsData.name} fund`,
    advisor: 'Neuberger Berman Investment Advisers, LLC',
    objectiveFocus: (<>Invests mainly in common stocks of mid&#45; to large&#45;capitalization companies. Seeks to reduce risk by investing across many different industries. The objective is long&#45;term growth of capital by investing primarily in securities of companies that meet the portfolio&#39;s quality oriented financial and ESG criteria.</>),
    assetClass: (<>Large&#45;Cap Stocks</>),
    style: [
      'Blend',
      'Mutual funds that follow social policies may underperform similar funds that do not have such policies.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: neubergerBermanAmtSustainableEquityFundPropsData.net_assets,
    topTen: [
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.top_ten[0].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.top_ten[0].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.top_ten[1].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.top_ten[1].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.top_ten[2].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.top_ten[2].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.top_ten[3].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.top_ten[3].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.top_ten[4].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.top_ten[4].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.top_ten[5].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.top_ten[5].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.top_ten[6].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.top_ten[6].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.top_ten[7].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.top_ten[7].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.top_ten[8].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.top_ten[8].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.top_ten[9].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.top_ten[9].name,
      },
    ],
    topTenTotal: neubergerBermanAmtSustainableEquityFundValsData.top_ten_total,
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[0].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[0].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[1].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[1].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[2].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[2].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[3].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[3].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[4].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[4].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[5].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[5].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[6].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[6].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[7].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[7].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[8].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[8].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[9].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[9].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[10].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[10].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[11].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[11].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[12].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[12].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[13].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[13].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[14].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[14].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[15].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[15].name,
      },
      {
        name: neubergerBermanAmtSustainableEquityFundPropsData.sector_weightings[16].name,
        percent: neubergerBermanAmtSustainableEquityFundValsData.sector_weightings[16].name,
      },
    ],
    appendPercentSign: true,
  },
  // /////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////
  // ██████╗░███████╗__███████╗██╗░░░██╗███╗░░██╗██████╗░░██████╗
  // ╚════██╗╚════██║__██╔════╝██║░░░██║████╗░██║██╔══██╗██╔════╝
  // ░░███╔═╝░░░░██╔╝__█████╗░░██║░░░██║██╔██╗██║██║░░██║╚█████╗░
  // ██╔══╝░░░░░██╔╝░__██╔══╝░░██║░░░██║██║╚████║██║░░██║░╚═══██╗
  // ███████╗░░██╔╝░░__██║░░░░░╚██████╔╝██║░╚███║██████╔╝██████╔╝
  // ╚══════╝░░╚═╝░░░__╚═╝░░░░░░╚═════╝░╚═╝░░╚══╝╚═════╝░╚═════╝░
  // ///////////////////////////////////////////////////
  // /////////////////////////////////////////////////
  assetAllocationFund: {
    pageTitle: `${assetAllocationFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    objectiveFocus: (<>The Portfolio will follow a flexible policy for allocating assets among 55&#8211;75&#37; equity securities, 25&#8211;45&#37; fixed income and debt securities, and 0&#8211;15&#37; cash equivalents. The Portfolios strategy is to adjust the mix between asset sectors to capitalize on the changing financial markets and economic conditions. The objective is to realize as high a level of total return as is consistent with reasonable investment risk.</>),
    assetClass: 'Flexible Portfolio',
    style: [
      (<>Hybrid&#45;Market&#45;Oriented for stocks, High&#47;Medium&#47;Low Credit Quality, Moderate Interest Rate Sensitivity for bonds, and High Quality, Short Maturity for money market.</>),
      'No investment strategy can guarantee a profit or protect against a loss.',
      'The Portfolio may gain exposure to foreign investments by investing in one or more of the Series Funds foreign portfolios. Each of those underlying portfolios has its own investment risks, including that it will not perform as expected. In addition, the Portfolio will bear a pro rata share of the underlying portfolios expenses.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>07&#45;31&#45;2001</>),
    firstAvailableVar: (<>07&#45;31&#45;2001</>),
    firstAvailableLife: (<>07&#45;31&#45;2001</>),
    netAssets: assetAllocationFundData.net_assets,
    topTen: [
      {
        name: assetAllocationFundData.top_ten[0].name,
        percent: assetAllocationFundData.top_ten[0].percent,
      },
      {
        name: assetAllocationFundData.top_ten[1].name,
        percent: assetAllocationFundData.top_ten[1].percent,
      },
      {
        name: assetAllocationFundData.top_ten[2].name,
        percent: assetAllocationFundData.top_ten[2].percent,
      },
      {
        name: assetAllocationFundData.top_ten[3].name,
        percent: assetAllocationFundData.top_ten[3].percent,
      },
      {
        name: assetAllocationFundData.top_ten[4].name,
        percent: assetAllocationFundData.top_ten[4].percent,
      },
      {
        name: assetAllocationFundData.top_ten[5].name,
        percent: assetAllocationFundData.top_ten[5].percent,
      },
      {
        name: assetAllocationFundData.top_ten[6].name,
        percent: assetAllocationFundData.top_ten[6].percent,
      },
      {
        name: assetAllocationFundData.top_ten[7].name,
        percent: assetAllocationFundData.top_ten[7].percent,
      },
      {
        name: assetAllocationFundData.top_ten[8].name,
        percent: assetAllocationFundData.top_ten[8].percent,
      },
      {
        name: assetAllocationFundData.top_ten[9].name,
        percent: assetAllocationFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: assetAllocationFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/asset-allocation.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: assetAllocationFundData.sector_weightings[0].name,
        percent: assetAllocationFundData.sector_weightings[0].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[1].name,
        percent: assetAllocationFundData.sector_weightings[1].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[2].name,
        percent: assetAllocationFundData.sector_weightings[2].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[3].name,
        percent: assetAllocationFundData.sector_weightings[3].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[4].name,
        percent: assetAllocationFundData.sector_weightings[4].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[5].name,
        percent: assetAllocationFundData.sector_weightings[5].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[6].name,
        percent: assetAllocationFundData.sector_weightings[6].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[7].name,
        percent: assetAllocationFundData.sector_weightings[7].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[8].name,
        percent: assetAllocationFundData.sector_weightings[8].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[9].name,
        percent: assetAllocationFundData.sector_weightings[9].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[10].name,
        percent: assetAllocationFundData.sector_weightings[10].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[11].name,
        percent: assetAllocationFundData.sector_weightings[11].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[12].name,
        percent: assetAllocationFundData.sector_weightings[12].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[13].name,
        percent: assetAllocationFundData.sector_weightings[13].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[14].name,
        percent: assetAllocationFundData.sector_weightings[14].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[15].name,
        percent: assetAllocationFundData.sector_weightings[15].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[16].name,
        percent: assetAllocationFundData.sector_weightings[16].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[17].name,
        percent: assetAllocationFundData.sector_weightings[17].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[18].name,
        percent: assetAllocationFundData.sector_weightings[18].percent,
      },
      {
        name: assetAllocationFundData.sector_weightings[19].name,
        percent: assetAllocationFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ////////////////////////////////////////////////////////////////////
  balancedFund: {
    pageTitle: `${balancedFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    objectiveFocus: (<>The Portfolio seeks to capitalize on changing financial markets and economic conditions following a flexible policy for allocating assets according to a benchmark of 35&#8211;55&#37; equities, 40&#8211;60&#37; fixed income or debt and 0&#8211;20&#37; money market instruments. The objective is to realize as high a level of total return rate as is consistent with prudent investment risk, through income and capital appreciation.</>),
    assetClass: 'Balanced',
    style: [
      (<>Hybrid&#45;Market&#45;Oriented for stocks, High&#47;Medium&#47;Low Credit Quality, Moderate Interest Rate Sensitivity for bonds, and High Quality, Short Maturity for money market.</>),
      'No investment strategy can guarantee a profit or protect against a loss.',
      'The Portfolio may gain exposure to foreign investments by investing in one or more of the Series Funds foreign portfolios. Each of those underlying portfolios has its own investment risks, including that it will not perform as expected. In addition, the Portfolio will bear a pro rata share of the underlying portfolios expenses.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>12&#45;31&#45;1981</>),
    firstAvailableVar: (<>12&#45;31&#45;1981</>),
    firstAvailableLife: (<>07&#45;01&#45;1984</>),
    netAssets: balancedFundData.net_assets,
    topTen: [
      {
        name: balancedFundData.top_ten[0].name,
        percent: balancedFundData.top_ten[0].percent,
      },
      {
        name: balancedFundData.top_ten[1].name,
        percent: balancedFundData.top_ten[1].percent,
      },
      {
        name: balancedFundData.top_ten[2].name,
        percent: balancedFundData.top_ten[2].percent,
      },
      {
        name: balancedFundData.top_ten[3].name,
        percent: balancedFundData.top_ten[3].percent,
      },
      {
        name: balancedFundData.top_ten[4].name,
        percent: balancedFundData.top_ten[4].percent,
      },
      {
        name: balancedFundData.top_ten[5].name,
        percent: balancedFundData.top_ten[5].percent,
      },
      {
        name: balancedFundData.top_ten[6].name,
        percent: balancedFundData.top_ten[6].percent,
      },
      {
        name: balancedFundData.top_ten[7].name,
        percent: balancedFundData.top_ten[7].percent,
      },
      {
        name: balancedFundData.top_ten[8].name,
        percent: balancedFundData.top_ten[8].percent,
      },
      {
        name: balancedFundData.top_ten[9].name,
        percent: balancedFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: balancedFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/balanced.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: balancedFundData.sector_weightings[0].name,
        percent: balancedFundData.sector_weightings[0].percent,
      },
      {
        name: balancedFundData.sector_weightings[1].name,
        percent: balancedFundData.sector_weightings[1].percent,
      },
      {
        name: balancedFundData.sector_weightings[2].name,
        percent: balancedFundData.sector_weightings[2].percent,
      },
      {
        name: balancedFundData.sector_weightings[3].name,
        percent: balancedFundData.sector_weightings[3].percent,
      },
      {
        name: balancedFundData.sector_weightings[4].name,
        percent: balancedFundData.sector_weightings[4].percent,
      },
      {
        name: balancedFundData.sector_weightings[5].name,
        percent: balancedFundData.sector_weightings[5].percent,
      },
      {
        name: balancedFundData.sector_weightings[6].name,
        percent: balancedFundData.sector_weightings[6].percent,
      },
      {
        name: balancedFundData.sector_weightings[7].name,
        percent: balancedFundData.sector_weightings[7].percent,
      },
      {
        name: balancedFundData.sector_weightings[8].name,
        percent: balancedFundData.sector_weightings[8].percent,
      },
      {
        name: balancedFundData.sector_weightings[9].name,
        percent: balancedFundData.sector_weightings[9].percent,
      },
      {
        name: balancedFundData.sector_weightings[10].name,
        percent: balancedFundData.sector_weightings[10].percent,
      },
      {
        name: balancedFundData.sector_weightings[11].name,
        percent: balancedFundData.sector_weightings[11].percent,
      },
      {
        name: balancedFundData.sector_weightings[12].name,
        percent: balancedFundData.sector_weightings[12].percent,
      },
      {
        name: balancedFundData.sector_weightings[13].name,
        percent: balancedFundData.sector_weightings[13].percent,
      },
      {
        name: balancedFundData.sector_weightings[14].name,
        percent: balancedFundData.sector_weightings[14].percent,
      },
      {
        name: balancedFundData.sector_weightings[15].name,
        percent: balancedFundData.sector_weightings[15].percent,
      },
      {
        name: balancedFundData.sector_weightings[16].name,
        percent: balancedFundData.sector_weightings[16].percent,
      },
      {
        name: balancedFundData.sector_weightings[17].name,
        percent: balancedFundData.sector_weightings[17].percent,
      },
      {
        name: balancedFundData.sector_weightings[18].name,
        percent: balancedFundData.sector_weightings[18].percent,
      },
      {
        name: balancedFundData.sector_weightings[19].name,
        percent: balancedFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ////////////////////////////////////////////////////////////////////
  domesticEquityFund: {
    pageTitle: `${domesticEquityFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'Delaware Investments Fund Advisers',
    objectiveFocus: (<>Invests primarily in a core group of 30&#8211;40 U.S. equity securities believed to be undervalued relative to their intrinsic value. The objective is to seek long&#45;term growth of capital and income.</>),
    assetClass: (<>Large&#45;Cap Stocks</>),
    style: [
      'Value',
      'Funds with a limited number of holdings may be more greatly affected by any single event or market development than funds that include more holdings.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>07&#45;31&#45;2001</>),
    firstAvailableVar: (<>07&#45;31&#45;2001</>),
    firstAvailableLife: (<>07&#45;31&#45;2001</>),
    netAssets: domesticEquityFundData.net_assets,
    topTen: [
      {
        name: domesticEquityFundData.top_ten[0].name,
        percent: domesticEquityFundData.top_ten[0].percent,
      },
      {
        name: domesticEquityFundData.top_ten[1].name,
        percent: domesticEquityFundData.top_ten[1].percent,
      },
      {
        name: domesticEquityFundData.top_ten[2].name,
        percent: domesticEquityFundData.top_ten[2].percent,
      },
      {
        name: domesticEquityFundData.top_ten[3].name,
        percent: domesticEquityFundData.top_ten[3].percent,
      },
      {
        name: domesticEquityFundData.top_ten[4].name,
        percent: domesticEquityFundData.top_ten[4].percent,
      },
      {
        name: domesticEquityFundData.top_ten[5].name,
        percent: domesticEquityFundData.top_ten[5].percent,
      },
      {
        name: domesticEquityFundData.top_ten[6].name,
        percent: domesticEquityFundData.top_ten[6].percent,
      },
      {
        name: domesticEquityFundData.top_ten[7].name,
        percent: domesticEquityFundData.top_ten[7].percent,
      },
      {
        name: domesticEquityFundData.top_ten[8].name,
        percent: domesticEquityFundData.top_ten[8].percent,
      },
      {
        name: domesticEquityFundData.top_ten[9].name,
        percent: domesticEquityFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: domesticEquityFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/domestic-equity.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: domesticEquityFundData.sector_weightings[0].name,
        percent: domesticEquityFundData.sector_weightings[0].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[1].name,
        percent: domesticEquityFundData.sector_weightings[1].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[2].name,
        percent: domesticEquityFundData.sector_weightings[2].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[3].name,
        percent: domesticEquityFundData.sector_weightings[3].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[4].name,
        percent: domesticEquityFundData.sector_weightings[4].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[5].name,
        percent: domesticEquityFundData.sector_weightings[5].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[6].name,
        percent: domesticEquityFundData.sector_weightings[6].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[7].name,
        percent: domesticEquityFundData.sector_weightings[7].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[8].name,
        percent: domesticEquityFundData.sector_weightings[8].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[9].name,
        percent: domesticEquityFundData.sector_weightings[9].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[10].name,
        percent: domesticEquityFundData.sector_weightings[10].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[11].name,
        percent: domesticEquityFundData.sector_weightings[11].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[12].name,
        percent: domesticEquityFundData.sector_weightings[12].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[13].name,
        percent: domesticEquityFundData.sector_weightings[13].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[14].name,
        percent: domesticEquityFundData.sector_weightings[14].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[15].name,
        percent: domesticEquityFundData.sector_weightings[15].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[16].name,
        percent: domesticEquityFundData.sector_weightings[16].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[17].name,
        percent: domesticEquityFundData.sector_weightings[17].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[18].name,
        percent: domesticEquityFundData.sector_weightings[18].percent,
      },
      {
        name: domesticEquityFundData.sector_weightings[19].name,
        percent: domesticEquityFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ////////////////////////////////////////////////////////////////////////////////////////
  emergingMarketsEquityFund: {
    pageTitle: `${emergingMarketsEquityFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'abrdn Investments Limited',
    objectiveFocus: (<>Normally invests at least 80&#37; of its net assets in equity securities of issuers that are tied economically to emerging market countries. May invest in companies of any size. The objective is capital appreciation</>),
    assetClass: 'Emerging Market International Stocks',
    style1: 'Blend',
    style2: 'Investments in emerging or developing markets involve exposure to economic structures that are generally less diverse and mature, and to political systems which have less stability than those of more developed countries. These securities are particularly subject to a risk of loss from political instability.',
    style3: 'Emerging market securities are subject to currency transfer restrictions and may experience delays and disruptions in securities settlement procedures for a Funds portfolio securities.',
    style4: 'The volatility of emerging markets can be significantly higher than other equity asset classes.',
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: emergingMarketsEquityFundData.net_assets,
    topTen: [
      {
        name: emergingMarketsEquityFundData.top_ten[0].name,
        percent: emergingMarketsEquityFundData.top_ten[0].percent,
      },
      {
        name: emergingMarketsEquityFundData.top_ten[1].name,
        percent: emergingMarketsEquityFundData.top_ten[1].percent,
      },
      {
        name: emergingMarketsEquityFundData.top_ten[2].name,
        percent: emergingMarketsEquityFundData.top_ten[2].percent,
      },
      {
        name: emergingMarketsEquityFundData.top_ten[3].name,
        percent: emergingMarketsEquityFundData.top_ten[3].percent,
      },
      {
        name: emergingMarketsEquityFundData.top_ten[4].name,
        percent: emergingMarketsEquityFundData.top_ten[4].percent,
      },
      {
        name: emergingMarketsEquityFundData.top_ten[5].name,
        percent: emergingMarketsEquityFundData.top_ten[5].percent,
      },
      {
        name: emergingMarketsEquityFundData.top_ten[6].name,
        percent: emergingMarketsEquityFundData.top_ten[6].percent,
      },
      {
        name: emergingMarketsEquityFundData.top_ten[7].name,
        percent: emergingMarketsEquityFundData.top_ten[7].percent,
      },
      {
        name: emergingMarketsEquityFundData.top_ten[8].name,
        percent: emergingMarketsEquityFundData.top_ten[8].percent,
      },
      {
        name: emergingMarketsEquityFundData.top_ten[9].name,
        percent: emergingMarketsEquityFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: emergingMarketsEquityFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/emerging-markets-equity.pdf',
    sectorWeightingsTitle: 'Geographic Allocation',
    sectorWeightings: [
      {
        name: emergingMarketsEquityFundData.sector_weightings[0].name,
        percent: emergingMarketsEquityFundData.sector_weightings[0].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[1].name,
        percent: emergingMarketsEquityFundData.sector_weightings[1].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[2].name,
        percent: emergingMarketsEquityFundData.sector_weightings[2].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[3].name,
        percent: emergingMarketsEquityFundData.sector_weightings[3].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[4].name,
        percent: emergingMarketsEquityFundData.sector_weightings[4].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[5].name,
        percent: emergingMarketsEquityFundData.sector_weightings[5].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[6].name,
        percent: emergingMarketsEquityFundData.sector_weightings[6].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[7].name,
        percent: emergingMarketsEquityFundData.sector_weightings[7].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[8].name,
        percent: emergingMarketsEquityFundData.sector_weightings[8].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[9].name,
        percent: emergingMarketsEquityFundData.sector_weightings[9].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[10].name,
        percent: emergingMarketsEquityFundData.sector_weightings[10].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[11].name,
        percent: emergingMarketsEquityFundData.sector_weightings[11].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[12].name,
        percent: emergingMarketsEquityFundData.sector_weightings[12].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[13].name,
        percent: emergingMarketsEquityFundData.sector_weightings[13].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[14].name,
        percent: emergingMarketsEquityFundData.sector_weightings[14].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[15].name,
        percent: emergingMarketsEquityFundData.sector_weightings[15].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[16].name,
        percent: emergingMarketsEquityFundData.sector_weightings[16].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[17].name,
        percent: emergingMarketsEquityFundData.sector_weightings[17].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[18].name,
        percent: emergingMarketsEquityFundData.sector_weightings[18].percent,
      },
      {
        name: emergingMarketsEquityFundData.sector_weightings[19].name,
        percent: emergingMarketsEquityFundData.sector_weightings[19].percent,
      },
    ],
  },
  // //////////////////////////////////////////////////////
  equityIncomeFund: {
    pageTitle: `${equityIncomeFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'T. Rowe Price Associates, Inc.',
    objectiveFocus: (<>Seeks companies that appear to be undervalued by various measures but have good prospects for capital appreciation and dividend growth. The fund will normally invest at least 80&#37; of net assets in common stocks, with a focus on companies paying above&#45;average dividends. The objective is long&#45;term growth of capital and income.</>),
    assetClass: (<>Large&#45;Cap Stocks</>),
    style: ['Value'],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>05&#45;01&#45;2003</>),
    firstAvailableVar: (<>05&#45;01&#45;2003</>),
    firstAvailableLife: (<>05&#45;01&#45;2003</>),
    netAssets: equityIncomeFundData.net_assets,
    topTen: [
      {
        name: equityIncomeFundData.top_ten[0].name,
        percent: equityIncomeFundData.top_ten[0].percent,
      },
      {
        name: equityIncomeFundData.top_ten[1].name,
        percent: equityIncomeFundData.top_ten[1].percent,
      },
      {
        name: equityIncomeFundData.top_ten[2].name,
        percent: equityIncomeFundData.top_ten[2].percent,
      },
      {
        name: equityIncomeFundData.top_ten[3].name,
        percent: equityIncomeFundData.top_ten[3].percent,
      },
      {
        name: equityIncomeFundData.top_ten[4].name,
        percent: equityIncomeFundData.top_ten[4].percent,
      },
      {
        name: equityIncomeFundData.top_ten[5].name,
        percent: equityIncomeFundData.top_ten[5].percent,
      },
      {
        name: equityIncomeFundData.top_ten[6].name,
        percent: equityIncomeFundData.top_ten[6].percent,
      },
      {
        name: equityIncomeFundData.top_ten[7].name,
        percent: equityIncomeFundData.top_ten[7].percent,
      },
      {
        name: equityIncomeFundData.top_ten[8].name,
        percent: equityIncomeFundData.top_ten[8].percent,
      },
      {
        name: equityIncomeFundData.top_ten[9].name,
        percent: equityIncomeFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: equityIncomeFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/equity-income.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: equityIncomeFundData.sector_weightings[0].name,
        percent: equityIncomeFundData.sector_weightings[0].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[1].name,
        percent: equityIncomeFundData.sector_weightings[1].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[2].name,
        percent: equityIncomeFundData.sector_weightings[2].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[3].name,
        percent: equityIncomeFundData.sector_weightings[3].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[4].name,
        percent: equityIncomeFundData.sector_weightings[4].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[5].name,
        percent: equityIncomeFundData.sector_weightings[5].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[6].name,
        percent: equityIncomeFundData.sector_weightings[6].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[7].name,
        percent: equityIncomeFundData.sector_weightings[7].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[8].name,
        percent: equityIncomeFundData.sector_weightings[8].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[9].name,
        percent: equityIncomeFundData.sector_weightings[9].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[10].name,
        percent: equityIncomeFundData.sector_weightings[10].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[11].name,
        percent: equityIncomeFundData.sector_weightings[11].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[12].name,
        percent: equityIncomeFundData.sector_weightings[12].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[13].name,
        percent: equityIncomeFundData.sector_weightings[13].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[14].name,
        percent: equityIncomeFundData.sector_weightings[14].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[15].name,
        percent: equityIncomeFundData.sector_weightings[15].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[16].name,
        percent: equityIncomeFundData.sector_weightings[16].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[17].name,
        percent: equityIncomeFundData.sector_weightings[17].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[18].name,
        percent: equityIncomeFundData.sector_weightings[18].percent,
      },
      {
        name: equityIncomeFundData.sector_weightings[19].name,
        percent: equityIncomeFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ////////////////////////////////////////////////////////////////////
  focusedAppreciationFund: {
    pageTitle: `${focusedAppreciationFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'Loomis Sayles Company',
    objectiveFocus: (<>Invests primarily in a core group of 20&#45;40 equity securities of companies selected for their growth potential. May invest in companies of any size from larger, well&#45;established issuers to smaller, emerging growth companies. The objective is long&#45;term capital growth.</>),
    assetClass: (<>Large&#45;Cap Stocks</>),
    style: [
      'Growth',
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks.',
      'Overseas investments can pose more risks than domestic investments. Unit values are subject to fluctuations in foreign stock markets, currency values, interest rates, government regulations and political conditions.',
      'Funds with a limited number of holdings may be more greatly affected by any single event or market development than funds that include more holdings.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>05&#45;01&#45;2003</>),
    firstAvailableVar: (<>05&#45;01&#45;2003</>),
    firstAvailableLife: (<>05&#45;01&#45;2003</>),
    netAssets: focusedAppreciationFundData.net_assets,
    topTen: [
      {
        name: focusedAppreciationFundData.top_ten[0].name,
        percent: focusedAppreciationFundData.top_ten[0].percent,
      },
      {
        name: focusedAppreciationFundData.top_ten[1].name,
        percent: focusedAppreciationFundData.top_ten[1].percent,
      },
      {
        name: focusedAppreciationFundData.top_ten[2].name,
        percent: focusedAppreciationFundData.top_ten[2].percent,
      },
      {
        name: focusedAppreciationFundData.top_ten[3].name,
        percent: focusedAppreciationFundData.top_ten[3].percent,
      },
      {
        name: focusedAppreciationFundData.top_ten[4].name,
        percent: focusedAppreciationFundData.top_ten[4].percent,
      },
      {
        name: focusedAppreciationFundData.top_ten[5].name,
        percent: focusedAppreciationFundData.top_ten[5].percent,
      },
      {
        name: focusedAppreciationFundData.top_ten[6].name,
        percent: focusedAppreciationFundData.top_ten[6].percent,
      },
      {
        name: focusedAppreciationFundData.top_ten[7].name,
        percent: focusedAppreciationFundData.top_ten[7].percent,
      },
      {
        name: focusedAppreciationFundData.top_ten[8].name,
        percent: focusedAppreciationFundData.top_ten[8].percent,
      },
      {
        name: focusedAppreciationFundData.top_ten[9].name,
        percent: focusedAppreciationFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: focusedAppreciationFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/focused-appreciation.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: focusedAppreciationFundData.sector_weightings[0].name,
        percent: focusedAppreciationFundData.sector_weightings[0].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[1].name,
        percent: focusedAppreciationFundData.sector_weightings[1].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[2].name,
        percent: focusedAppreciationFundData.sector_weightings[2].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[3].name,
        percent: focusedAppreciationFundData.sector_weightings[3].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[4].name,
        percent: focusedAppreciationFundData.sector_weightings[4].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[5].name,
        percent: focusedAppreciationFundData.sector_weightings[5].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[6].name,
        percent: focusedAppreciationFundData.sector_weightings[6].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[7].name,
        percent: focusedAppreciationFundData.sector_weightings[7].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[8].name,
        percent: focusedAppreciationFundData.sector_weightings[8].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[9].name,
        percent: focusedAppreciationFundData.sector_weightings[9].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[10].name,
        percent: focusedAppreciationFundData.sector_weightings[10].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[11].name,
        percent: focusedAppreciationFundData.sector_weightings[11].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[12].name,
        percent: focusedAppreciationFundData.sector_weightings[12].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[13].name,
        percent: focusedAppreciationFundData.sector_weightings[13].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[14].name,
        percent: focusedAppreciationFundData.sector_weightings[14].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[15].name,
        percent: focusedAppreciationFundData.sector_weightings[15].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[16].name,
        percent: focusedAppreciationFundData.sector_weightings[16].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[17].name,
        percent: focusedAppreciationFundData.sector_weightings[17].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[18].name,
        percent: focusedAppreciationFundData.sector_weightings[18].percent,
      },
      {
        name: focusedAppreciationFundData.sector_weightings[19].name,
        percent: focusedAppreciationFundData.sector_weightings[19].percent,
      },
    ],
  },
  // /////////////////////////////////////////////////
  governmentMoneyMarketFund: {
    pageTitle: `${governmentMoneyMarketFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'BlackRock Advisors, LLC',
    objectiveFocus: (<>Invests in high&#45;quality money market instruments and other debt securities with maturities generally not exceeding one year. The objective is to generate maximum current income consistent with liquidity and stability of capital.</>),
    assetClass: 'Cash',
    style: [
      'High Quality',
      (<>You could lose money by investing in the Fund. Although the Fund seeks to preserve the value of your investment at &#36;1.00 per share, it cannot guarantee it will do so. An investment in the Fund is not insured or guaranteed by the Federal Deposit Insurance Corporation or any other government agency. The Fund&#39;s sponsor has no legal obligation to provide financial support to the Fund, and you should not expect that the sponsor will provide financial support to the Fund at any time.</>),
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>12&#45;31&#45;1981</>),
    firstAvailableVar: (<>07&#45;01&#45;1984</>),
    firstAvailableLife: (<>05&#45;03&#45;1994</>),
    netAssets: governmentMoneyMarketFundData.net_assets,
    topTen: [
      {
        name: governmentMoneyMarketFundData.top_ten[0].name,
        percent: governmentMoneyMarketFundData.top_ten[0].percent,
      },
      {
        name: governmentMoneyMarketFundData.top_ten[1].name,
        percent: governmentMoneyMarketFundData.top_ten[1].percent,
      },
      {
        name: governmentMoneyMarketFundData.top_ten[2].name,
        percent: governmentMoneyMarketFundData.top_ten[2].percent,
      },
      {
        name: governmentMoneyMarketFundData.top_ten[3].name,
        percent: governmentMoneyMarketFundData.top_ten[3].percent,
      },
      {
        name: governmentMoneyMarketFundData.top_ten[4].name,
        percent: governmentMoneyMarketFundData.top_ten[4].percent,
      },
      {
        name: governmentMoneyMarketFundData.top_ten[5].name,
        percent: governmentMoneyMarketFundData.top_ten[5].percent,
      },
      {
        name: governmentMoneyMarketFundData.top_ten[6].name,
        percent: governmentMoneyMarketFundData.top_ten[6].percent,
      },
      {
        name: governmentMoneyMarketFundData.top_ten[7].name,
        percent: governmentMoneyMarketFundData.top_ten[7].percent,
      },
      {
        name: governmentMoneyMarketFundData.top_ten[8].name,
        percent: governmentMoneyMarketFundData.top_ten[8].percent,
      },
      {
        name: governmentMoneyMarketFundData.top_ten[9].name,
        percent: governmentMoneyMarketFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: governmentMoneyMarketFundData.top_ten_total,
    // pdfLink: '/assets/pdf/portfolio-holdings/growth-stock.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: governmentMoneyMarketFundData.sector_weightings[0].name,
        percent: governmentMoneyMarketFundData.sector_weightings[0].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[1].name,
        percent: governmentMoneyMarketFundData.sector_weightings[1].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[2].name,
        percent: governmentMoneyMarketFundData.sector_weightings[2].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[3].name,
        percent: governmentMoneyMarketFundData.sector_weightings[3].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[4].name,
        percent: governmentMoneyMarketFundData.sector_weightings[4].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[5].name,
        percent: governmentMoneyMarketFundData.sector_weightings[5].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[6].name,
        percent: governmentMoneyMarketFundData.sector_weightings[6].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[7].name,
        percent: governmentMoneyMarketFundData.sector_weightings[7].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[8].name,
        percent: governmentMoneyMarketFundData.sector_weightings[8].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[9].name,
        percent: governmentMoneyMarketFundData.sector_weightings[9].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[10].name,
        percent: governmentMoneyMarketFundData.sector_weightings[10].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[11].name,
        percent: governmentMoneyMarketFundData.sector_weightings[11].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[12].name,
        percent: governmentMoneyMarketFundData.sector_weightings[12].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[13].name,
        percent: governmentMoneyMarketFundData.sector_weightings[13].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[14].name,
        percent: governmentMoneyMarketFundData.sector_weightings[14].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[15].name,
        percent: governmentMoneyMarketFundData.sector_weightings[15].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[16].name,
        percent: governmentMoneyMarketFundData.sector_weightings[16].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[17].name,
        percent: governmentMoneyMarketFundData.sector_weightings[17].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[18].name,
        percent: governmentMoneyMarketFundData.sector_weightings[18].percent,
      },
      {
        name: governmentMoneyMarketFundData.sector_weightings[19].name,
        percent: governmentMoneyMarketFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ///////////////////////////////////////////////////////////////////////////////
  growthStockFund: {
    pageTitle: `${growthStockFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'T. Rowe Price Associates, Inc.',
    objectiveFocus: (<>Invests in a diversified mix of equity securities of well established medium and large capitalization companies with above average earnings growth potential. The objective is long&#45;term capital growth. Current income is a secondary objective.</>),
    assetClass: (<>Large&#45;Cap Stocks</>),
    style: ['Growth'],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>05&#45;03&#45;1994</>),
    firstAvailableVar: (<>05&#45;03&#45;1994</>),
    firstAvailableLife: (<>05&#45;03&#45;1994</>),
    netAssets: growthStockFundData.net_assets,
    topTen: [
      {
        name: growthStockFundData.top_ten[0].name,
        percent: growthStockFundData.top_ten[0].percent,
      },
      {
        name: growthStockFundData.top_ten[1].name,
        percent: growthStockFundData.top_ten[1].percent,
      },
      {
        name: growthStockFundData.top_ten[2].name,
        percent: growthStockFundData.top_ten[2].percent,
      },
      {
        name: growthStockFundData.top_ten[3].name,
        percent: growthStockFundData.top_ten[3].percent,
      },
      {
        name: growthStockFundData.top_ten[4].name,
        percent: growthStockFundData.top_ten[4].percent,
      },
      {
        name: growthStockFundData.top_ten[5].name,
        percent: growthStockFundData.top_ten[5].percent,
      },
      {
        name: growthStockFundData.top_ten[6].name,
        percent: growthStockFundData.top_ten[6].percent,
      },
      {
        name: growthStockFundData.top_ten[7].name,
        percent: growthStockFundData.top_ten[7].percent,
      },
      {
        name: growthStockFundData.top_ten[8].name,
        percent: growthStockFundData.top_ten[8].percent,
      },
      {
        name: growthStockFundData.top_ten[9].name,
        percent: growthStockFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: growthStockFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/growth-stock.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: growthStockFundData.sector_weightings[0].name,
        percent: growthStockFundData.sector_weightings[0].percent,
      },
      {
        name: growthStockFundData.sector_weightings[1].name,
        percent: growthStockFundData.sector_weightings[1].percent,
      },
      {
        name: growthStockFundData.sector_weightings[2].name,
        percent: growthStockFundData.sector_weightings[2].percent,
      },
      {
        name: growthStockFundData.sector_weightings[3].name,
        percent: growthStockFundData.sector_weightings[3].percent,
      },
      {
        name: growthStockFundData.sector_weightings[4].name,
        percent: growthStockFundData.sector_weightings[4].percent,
      },
      {
        name: growthStockFundData.sector_weightings[5].name,
        percent: growthStockFundData.sector_weightings[5].percent,
      },
      {
        name: growthStockFundData.sector_weightings[6].name,
        percent: growthStockFundData.sector_weightings[6].percent,
      },
      {
        name: growthStockFundData.sector_weightings[7].name,
        percent: growthStockFundData.sector_weightings[7].percent,
      },
      {
        name: growthStockFundData.sector_weightings[8].name,
        percent: growthStockFundData.sector_weightings[8].percent,
      },
      {
        name: growthStockFundData.sector_weightings[9].name,
        percent: growthStockFundData.sector_weightings[9].percent,
      },
      {
        name: growthStockFundData.sector_weightings[10].name,
        percent: growthStockFundData.sector_weightings[10].percent,
      },
      {
        name: growthStockFundData.sector_weightings[11].name,
        percent: growthStockFundData.sector_weightings[11].percent,
      },
      {
        name: growthStockFundData.sector_weightings[12].name,
        percent: growthStockFundData.sector_weightings[12].percent,
      },
      {
        name: growthStockFundData.sector_weightings[13].name,
        percent: growthStockFundData.sector_weightings[13].percent,
      },
      {
        name: growthStockFundData.sector_weightings[14].name,
        percent: growthStockFundData.sector_weightings[14].percent,
      },
      {
        name: growthStockFundData.sector_weightings[15].name,
        percent: growthStockFundData.sector_weightings[15].percent,
      },
      {
        name: growthStockFundData.sector_weightings[16].name,
        percent: growthStockFundData.sector_weightings[16].percent,
      },
      {
        name: growthStockFundData.sector_weightings[17].name,
        percent: growthStockFundData.sector_weightings[17].percent,
      },
      {
        name: growthStockFundData.sector_weightings[18].name,
        percent: growthStockFundData.sector_weightings[18].percent,
      },
      {
        name: growthStockFundData.sector_weightings[19].name,
        percent: growthStockFundData.sector_weightings[19].percent,
      },
    ],
  },
  // //////////////////////////////////////////////////////////////////
  highYieldBondFund: {
    pageTitle: `${highYieldBondFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'Federated Investment Management Company',
    objectiveFocus: (<>Normally invests at least 80&#37; of net assets in non&#45;investment grade debt securities. The objective is to achieve high current income and capital appreciation.</>),
    assetClass: 'Bond',
    style: [
      (<>Medium&#47;Low Credit Quality, Moderate Interest Rate Sensitivity</>),
      'Bonds and other debt obligations are affected by changes in interest rates, inflation risk and the creditworthiness of their issuers. High yield bonds generally have greater price swings and higher default risks than investment grade bonds. Return of principal is not guaranteed. In contrast to owning individual bonds, there are ongoing fees and expenses associated with owning shares of bond funds.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>05&#45;03&#45;1994</>),
    firstAvailableVar: (<>05&#45;03&#45;1994</>),
    firstAvailableLife: (<>05&#45;03&#45;1994</>),
    netAssets: highYieldBondFundData.net_assets,
    topTen: [
      {
        name: highYieldBondFundData.top_ten[0].name,
        percent: highYieldBondFundData.top_ten[0].percent,
      },
      {
        name: highYieldBondFundData.top_ten[1].name,
        percent: highYieldBondFundData.top_ten[1].percent,
      },
      {
        name: highYieldBondFundData.top_ten[2].name,
        percent: highYieldBondFundData.top_ten[2].percent,
      },
      {
        name: highYieldBondFundData.top_ten[3].name,
        percent: highYieldBondFundData.top_ten[3].percent,
      },
      {
        name: highYieldBondFundData.top_ten[4].name,
        percent: highYieldBondFundData.top_ten[4].percent,
      },
      {
        name: highYieldBondFundData.top_ten[5].name,
        percent: highYieldBondFundData.top_ten[5].percent,
      },
      {
        name: highYieldBondFundData.top_ten[6].name,
        percent: highYieldBondFundData.top_ten[6].percent,
      },
      {
        name: highYieldBondFundData.top_ten[7].name,
        percent: highYieldBondFundData.top_ten[7].percent,
      },
      {
        name: highYieldBondFundData.top_ten[8].name,
        percent: highYieldBondFundData.top_ten[8].percent,
      },
      {
        name: highYieldBondFundData.top_ten[9].name,
        percent: highYieldBondFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: highYieldBondFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/high-yield-bond.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: highYieldBondFundData.sector_weightings[0].name,
        percent: highYieldBondFundData.sector_weightings[0].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[1].name,
        percent: highYieldBondFundData.sector_weightings[1].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[2].name,
        percent: highYieldBondFundData.sector_weightings[2].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[3].name,
        percent: highYieldBondFundData.sector_weightings[3].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[4].name,
        percent: highYieldBondFundData.sector_weightings[4].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[5].name,
        percent: highYieldBondFundData.sector_weightings[5].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[6].name,
        percent: highYieldBondFundData.sector_weightings[6].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[7].name,
        percent: highYieldBondFundData.sector_weightings[7].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[8].name,
        percent: highYieldBondFundData.sector_weightings[8].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[9].name,
        percent: highYieldBondFundData.sector_weightings[9].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[10].name,
        percent: highYieldBondFundData.sector_weightings[10].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[11].name,
        percent: highYieldBondFundData.sector_weightings[11].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[12].name,
        percent: highYieldBondFundData.sector_weightings[12].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[13].name,
        percent: highYieldBondFundData.sector_weightings[13].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[14].name,
        percent: highYieldBondFundData.sector_weightings[14].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[15].name,
        percent: highYieldBondFundData.sector_weightings[15].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[16].name,
        percent: highYieldBondFundData.sector_weightings[16].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[17].name,
        percent: highYieldBondFundData.sector_weightings[17].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[18].name,
        percent: highYieldBondFundData.sector_weightings[18].percent,
      },
      {
        name: highYieldBondFundData.sector_weightings[19].name,
        percent: highYieldBondFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ////////////////////////////////////////////////////////////
  index400StockFund: {
    pageTitle: `${index400StockFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'Northern Trust Investments, Inc.',
    objectiveFocus: (<>Invests substantially all of its assets in the stocks in the S&#38;P MidCap 400&#174; Index, which is an unmanaged index of 400 selected common stocks compiled by Standard &#38; Poor&#39;s&#174; and weighted toward medium market capitalizations. The objective is to achieve investment results that approximate the performance of the S&#38;P MidCap 400&#174; Index.</>),
    assetClass: (<>Mid&#45;Cap Stocks</>),
    style: [
      (<>Blend&#47;Market&#45;Oriented</>),
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks. Indices are unmanaged, cannot be invested in directly.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;1999</>),
    firstAvailableVar: (<>04&#45;30&#45;1999</>),
    firstAvailableLife: (<>06&#45;30&#45;1999</>),
    netAssets: index400StockFundData.net_assets,
    topTen: [
      {
        name: index400StockFundData.top_ten[0].name,
        percent: index400StockFundData.top_ten[0].percent,
      },
      {
        name: index400StockFundData.top_ten[1].name,
        percent: index400StockFundData.top_ten[1].percent,
      },
      {
        name: index400StockFundData.top_ten[2].name,
        percent: index400StockFundData.top_ten[2].percent,
      },
      {
        name: index400StockFundData.top_ten[3].name,
        percent: index400StockFundData.top_ten[3].percent,
      },
      {
        name: index400StockFundData.top_ten[4].name,
        percent: index400StockFundData.top_ten[4].percent,
      },
      {
        name: index400StockFundData.top_ten[5].name,
        percent: index400StockFundData.top_ten[5].percent,
      },
      {
        name: index400StockFundData.top_ten[6].name,
        percent: index400StockFundData.top_ten[6].percent,
      },
      {
        name: index400StockFundData.top_ten[7].name,
        percent: index400StockFundData.top_ten[7].percent,
      },
      {
        name: index400StockFundData.top_ten[8].name,
        percent: index400StockFundData.top_ten[8].percent,
      },
      {
        name: index400StockFundData.top_ten[9].name,
        percent: index400StockFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: index400StockFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/index-400-stock.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: index400StockFundData.sector_weightings[0].name,
        percent: index400StockFundData.sector_weightings[0].percent,
      },
      {
        name: index400StockFundData.sector_weightings[1].name,
        percent: index400StockFundData.sector_weightings[1].percent,
      },
      {
        name: index400StockFundData.sector_weightings[2].name,
        percent: index400StockFundData.sector_weightings[2].percent,
      },
      {
        name: index400StockFundData.sector_weightings[3].name,
        percent: index400StockFundData.sector_weightings[3].percent,
      },
      {
        name: index400StockFundData.sector_weightings[4].name,
        percent: index400StockFundData.sector_weightings[4].percent,
      },
      {
        name: index400StockFundData.sector_weightings[5].name,
        percent: index400StockFundData.sector_weightings[5].percent,
      },
      {
        name: index400StockFundData.sector_weightings[6].name,
        percent: index400StockFundData.sector_weightings[6].percent,
      },
      {
        name: index400StockFundData.sector_weightings[7].name,
        percent: index400StockFundData.sector_weightings[7].percent,
      },
      {
        name: index400StockFundData.sector_weightings[8].name,
        percent: index400StockFundData.sector_weightings[8].percent,
      },
      {
        name: index400StockFundData.sector_weightings[9].name,
        percent: index400StockFundData.sector_weightings[9].percent,
      },
      {
        name: index400StockFundData.sector_weightings[10].name,
        percent: index400StockFundData.sector_weightings[10].percent,
      },
      {
        name: index400StockFundData.sector_weightings[11].name,
        percent: index400StockFundData.sector_weightings[11].percent,
      },
      {
        name: index400StockFundData.sector_weightings[12].name,
        percent: index400StockFundData.sector_weightings[12].percent,
      },
      {
        name: index400StockFundData.sector_weightings[13].name,
        percent: index400StockFundData.sector_weightings[13].percent,
      },
      {
        name: index400StockFundData.sector_weightings[14].name,
        percent: index400StockFundData.sector_weightings[14].percent,
      },
      {
        name: index400StockFundData.sector_weightings[15].name,
        percent: index400StockFundData.sector_weightings[15].percent,
      },
      {
        name: index400StockFundData.sector_weightings[16].name,
        percent: index400StockFundData.sector_weightings[16].percent,
      },
      {
        name: index400StockFundData.sector_weightings[17].name,
        percent: index400StockFundData.sector_weightings[17].percent,
      },
      {
        name: index400StockFundData.sector_weightings[18].name,
        percent: index400StockFundData.sector_weightings[18].percent,
      },
      {
        name: index400StockFundData.sector_weightings[19].name,
        percent: index400StockFundData.sector_weightings[19].percent,
      },
    ],
  },
  // /////////////////////////////////////////////////////////////
  index500StockFund: {
    pageTitle: `${index500StockFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'BlackRock Advisors, LLC',
    objectiveFocus: (<>Invests substantially all of its assets in the stocks in the S&#38;P 500&#174; Index, which is an unmanaged index of 500 selected common stocks compiled by Standard & Poor&#39;s&#174; and weighted toward large market capitalizations. The objective is to achieve investment results that approximate the performance of the S&#38;P 500&#174; Index.</>),
    assetClass: (<>Large&#45;Cap Stocks</>),
    style: [
      (<>Blend&#47;Market&#45;Oriented</>),
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks. Indices are unmanaged, cannot be invested in directly.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>12&#45;12&#45;1990</>),
    firstAvailableVar: (<>07&#45;31&#45;1984</>),
    firstAvailableVarSupplementalText: 'The original Variable Annuity and Variable Life funds merged on May 3, 1994. This fund was actively managed prior to May 3, 1994.',
    firstAvailableLife: '',
    netAssets: index500StockFundData.net_assets,
    topTen: [
      {
        name: index500StockFundData.top_ten[0].name,
        percent: index500StockFundData.top_ten[0].percent,
      },
      {
        name: index500StockFundData.top_ten[1].name,
        percent: index500StockFundData.top_ten[1].percent,
      },
      {
        name: index500StockFundData.top_ten[2].name,
        percent: index500StockFundData.top_ten[2].percent,
      },
      {
        name: index500StockFundData.top_ten[3].name,
        percent: index500StockFundData.top_ten[3].percent,
      },
      {
        name: index500StockFundData.top_ten[4].name,
        percent: index500StockFundData.top_ten[4].percent,
      },
      {
        name: index500StockFundData.top_ten[5].name,
        percent: index500StockFundData.top_ten[5].percent,
      },
      {
        name: index500StockFundData.top_ten[6].name,
        percent: index500StockFundData.top_ten[6].percent,
      },
      {
        name: index500StockFundData.top_ten[7].name,
        percent: index500StockFundData.top_ten[7].percent,
      },
      {
        name: index500StockFundData.top_ten[8].name,
        percent: index500StockFundData.top_ten[8].percent,
      },
      {
        name: index500StockFundData.top_ten[9].name,
        percent: index500StockFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: index500StockFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/index-500-stock.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: index500StockFundData.sector_weightings[0].name,
        percent: index500StockFundData.sector_weightings[0].percent,
      },
      {
        name: index500StockFundData.sector_weightings[1].name,
        percent: index500StockFundData.sector_weightings[1].percent,
      },
      {
        name: index500StockFundData.sector_weightings[2].name,
        percent: index500StockFundData.sector_weightings[2].percent,
      },
      {
        name: index500StockFundData.sector_weightings[3].name,
        percent: index500StockFundData.sector_weightings[3].percent,
      },
      {
        name: index500StockFundData.sector_weightings[4].name,
        percent: index500StockFundData.sector_weightings[4].percent,
      },
      {
        name: index500StockFundData.sector_weightings[5].name,
        percent: index500StockFundData.sector_weightings[5].percent,
      },
      {
        name: index500StockFundData.sector_weightings[6].name,
        percent: index500StockFundData.sector_weightings[6].percent,
      },
      {
        name: index500StockFundData.sector_weightings[7].name,
        percent: index500StockFundData.sector_weightings[7].percent,
      },
      {
        name: index500StockFundData.sector_weightings[8].name,
        percent: index500StockFundData.sector_weightings[8].percent,
      },
      {
        name: index500StockFundData.sector_weightings[9].name,
        percent: index500StockFundData.sector_weightings[9].percent,
      },
      {
        name: index500StockFundData.sector_weightings[10].name,
        percent: index500StockFundData.sector_weightings[10].percent,
      },
      {
        name: index500StockFundData.sector_weightings[11].name,
        percent: index500StockFundData.sector_weightings[11].percent,
      },
      {
        name: index500StockFundData.sector_weightings[12].name,
        percent: index500StockFundData.sector_weightings[12].percent,
      },
      {
        name: index500StockFundData.sector_weightings[13].name,
        percent: index500StockFundData.sector_weightings[13].percent,
      },
      {
        name: index500StockFundData.sector_weightings[14].name,
        percent: index500StockFundData.sector_weightings[14].percent,
      },
      {
        name: index500StockFundData.sector_weightings[15].name,
        percent: index500StockFundData.sector_weightings[15].percent,
      },
      {
        name: index500StockFundData.sector_weightings[16].name,
        percent: index500StockFundData.sector_weightings[16].percent,
      },
      {
        name: index500StockFundData.sector_weightings[17].name,
        percent: index500StockFundData.sector_weightings[17].percent,
      },
      {
        name: index500StockFundData.sector_weightings[18].name,
        percent: index500StockFundData.sector_weightings[18].percent,
      },
      {
        name: index500StockFundData.sector_weightings[19].name,
        percent: index500StockFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ////////////////////////////////////////////////////////////////
  index600StockFund: {
    pageTitle:  `${index600StockFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'Northern Trust Investments, Inc.',
    objectiveFocus: (<>The objective is to achieve investment results that approximate the performance of the S&#38;P SmallCap 600&#174; Index.</>),
    assetClass: (<>Small&#45;Cap Stocks</>),
    style: [
      'Blend',
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks.',
      'Indices are unmanaged, cannot be invested in directly.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: index600StockFundData.net_assets,
    topTen: [
      {
        name: index600StockFundData.top_ten[0].name,
        percent: index600StockFundData.top_ten[0].percent,
      },
      {
        name: index600StockFundData.top_ten[1].name,
        percent: index600StockFundData.top_ten[1].percent,
      },
      {
        name: index600StockFundData.top_ten[2].name,
        percent: index600StockFundData.top_ten[2].percent,
      },
      {
        name: index600StockFundData.top_ten[3].name,
        percent: index600StockFundData.top_ten[3].percent,
      },
      {
        name: index600StockFundData.top_ten[4].name,
        percent: index600StockFundData.top_ten[4].percent,
      },
      {
        name: index600StockFundData.top_ten[5].name,
        percent: index600StockFundData.top_ten[5].percent,
      },
      {
        name: index600StockFundData.top_ten[6].name,
        percent: index600StockFundData.top_ten[6].percent,
      },
      {
        name: index600StockFundData.top_ten[7].name,
        percent: index600StockFundData.top_ten[7].percent,
      },
      {
        name: index600StockFundData.top_ten[8].name,
        percent: index600StockFundData.top_ten[8].percent,
      },
      {
        name: index600StockFundData.top_ten[9].name,
        percent: index600StockFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: index600StockFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/index-600-stock.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: index600StockFundData.sector_weightings[0].name,
        percent: index600StockFundData.sector_weightings[0].percent,
      },
      {
        name: index600StockFundData.sector_weightings[1].name,
        percent: index600StockFundData.sector_weightings[1].percent,
      },
      {
        name: index600StockFundData.sector_weightings[2].name,
        percent: index600StockFundData.sector_weightings[2].percent,
      },
      {
        name: index600StockFundData.sector_weightings[3].name,
        percent: index600StockFundData.sector_weightings[3].percent,
      },
      {
        name: index600StockFundData.sector_weightings[4].name,
        percent: index600StockFundData.sector_weightings[4].percent,
      },
      {
        name: index600StockFundData.sector_weightings[5].name,
        percent: index600StockFundData.sector_weightings[5].percent,
      },
      {
        name: index600StockFundData.sector_weightings[6].name,
        percent: index600StockFundData.sector_weightings[6].percent,
      },
      {
        name: index600StockFundData.sector_weightings[7].name,
        percent: index600StockFundData.sector_weightings[7].percent,
      },
      {
        name: index600StockFundData.sector_weightings[8].name,
        percent: index600StockFundData.sector_weightings[8].percent,
      },
      {
        name: index600StockFundData.sector_weightings[9].name,
        percent: index600StockFundData.sector_weightings[9].percent,
      },
      {
        name: index600StockFundData.sector_weightings[10].name,
        percent: index600StockFundData.sector_weightings[10].percent,
      },
      {
        name: index600StockFundData.sector_weightings[11].name,
        percent: index600StockFundData.sector_weightings[11].percent,
      },
      {
        name: index600StockFundData.sector_weightings[12].name,
        percent: index600StockFundData.sector_weightings[12].percent,
      },
      {
        name: index600StockFundData.sector_weightings[13].name,
        percent: index600StockFundData.sector_weightings[13].percent,
      },
      {
        name: index600StockFundData.sector_weightings[14].name,
        percent: index600StockFundData.sector_weightings[14].percent,
      },
      {
        name: index600StockFundData.sector_weightings[15].name,
        percent: index600StockFundData.sector_weightings[15].percent,
      },
      {
        name: index600StockFundData.sector_weightings[16].name,
        percent: index600StockFundData.sector_weightings[16].percent,
      },
      {
        name: index600StockFundData.sector_weightings[17].name,
        percent: index600StockFundData.sector_weightings[17].percent,
      },
      {
        name: index600StockFundData.sector_weightings[18].name,
        percent: index600StockFundData.sector_weightings[18].percent,
      },
      {
        name: index600StockFundData.sector_weightings[19].name,
        percent: index600StockFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ///////////////////////////////////////////////////////////////
  inflationProtectionFund: {
    pageTitle: `${inflationProtectionFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'American Century Investment Management, Inc.',
    objectiveFocus: (<>The Portfolio invests substantially all of its assets in investment grade debt securities. To help protect against U.S. inflation, under normal conditions, the Portfolio will invest over 50&#37; of its net assets in inflation&#45;linked debt securities. The objective is to pursue total return using a strategy that seeks to protect against U.S. inflation.</>),
    assetClass: 'Bond',
    style: [
      'High Quality, Intermediate Maturity',
      (<>Return of principal is not guaranteed. Bond funds have the same interest rate, inflation and credit risks that are associated with the underlying bonds owned by the Fund. When interest rates rise, bond prices fall. With a fixed income fund, when interest rates rise, the value of the fund&#39;s existing bonds drops, which could negatively affect overall fund performance</>),
      (<>Investors should be aware of the risks of investments in foreign securities, particularly investments in securities of companies in developing nations. These include the risks of currency fluctuation, of political and economic instability and of less well&#45;developed government supervision and regulation of business and industry practices, as well as differences in accounting standards.</>),
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: inflationProtectionFundData.net_assets,
    topTen: [
      {
        name: inflationProtectionFundData.top_ten[0].name,
        percent: inflationProtectionFundData.top_ten[0].percent,
      },
      {
        name: inflationProtectionFundData.top_ten[1].name,
        percent: inflationProtectionFundData.top_ten[1].percent,
      },
      {
        name: inflationProtectionFundData.top_ten[2].name,
        percent: inflationProtectionFundData.top_ten[2].percent,
      },
      {
        name: inflationProtectionFundData.top_ten[3].name,
        percent: inflationProtectionFundData.top_ten[3].percent,
      },
      {
        name: inflationProtectionFundData.top_ten[4].name,
        percent: inflationProtectionFundData.top_ten[4].percent,
      },
      {
        name: inflationProtectionFundData.top_ten[5].name,
        percent: inflationProtectionFundData.top_ten[5].percent,
      },
      {
        name: inflationProtectionFundData.top_ten[6].name,
        percent: inflationProtectionFundData.top_ten[6].percent,
      },
      {
        name: inflationProtectionFundData.top_ten[7].name,
        percent: inflationProtectionFundData.top_ten[7].percent,
      },
      {
        name: inflationProtectionFundData.top_ten[8].name,
        percent: inflationProtectionFundData.top_ten[8].percent,
      },
      {
        name: inflationProtectionFundData.top_ten[9].name,
        percent: inflationProtectionFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: inflationProtectionFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/inflation-protection.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: inflationProtectionFundData.sector_weightings[0].name,
        percent: inflationProtectionFundData.sector_weightings[0].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[1].name,
        percent: inflationProtectionFundData.sector_weightings[1].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[2].name,
        percent: inflationProtectionFundData.sector_weightings[2].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[3].name,
        percent: inflationProtectionFundData.sector_weightings[3].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[4].name,
        percent: inflationProtectionFundData.sector_weightings[4].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[5].name,
        percent: inflationProtectionFundData.sector_weightings[5].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[6].name,
        percent: inflationProtectionFundData.sector_weightings[6].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[7].name,
        percent: inflationProtectionFundData.sector_weightings[7].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[8].name,
        percent: inflationProtectionFundData.sector_weightings[8].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[9].name,
        percent: inflationProtectionFundData.sector_weightings[9].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[10].name,
        percent: inflationProtectionFundData.sector_weightings[10].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[11].name,
        percent: inflationProtectionFundData.sector_weightings[11].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[12].name,
        percent: inflationProtectionFundData.sector_weightings[12].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[13].name,
        percent: inflationProtectionFundData.sector_weightings[13].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[14].name,
        percent: inflationProtectionFundData.sector_weightings[14].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[15].name,
        percent: inflationProtectionFundData.sector_weightings[15].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[16].name,
        percent: inflationProtectionFundData.sector_weightings[16].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[17].name,
        percent: inflationProtectionFundData.sector_weightings[17].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[18].name,
        percent: inflationProtectionFundData.sector_weightings[18].percent,
      },
      {
        name: inflationProtectionFundData.sector_weightings[19].name,
        percent: inflationProtectionFundData.sector_weightings[19].percent,
      },
    ],
  },
  // //////////////////////////////////////////////////////////
  internationalEquityFund: {
    pageTitle: `${internationalEquityFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: (<>Dodge &#38; Cox</>),
    objectiveFocus: (<>Primarily invests in stocks of non&#45;U.S. companies believed to be undervalued. Investments may include small, medium and large capitalization issues. The objective is long&#45;term capital growth.</>),
    assetClass: 'International Stocks',
    style: [
      'Value',
      'Overseas investments can pose more risks than domestic investments. Unit values are subject to fluctuations in foreign stock markets, currency values, interest rates, government regulations and political conditions.',
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;1993</>),
    firstAvailableVar: (<>04&#45;30&#45;1993</>),
    firstAvailableLife: (<>05&#45;03&#45;1994</>),
    netAssets: internationalEquityFundData.net_assets,
    topTen: [
      {
        name: internationalEquityFundData.top_ten[0].name,
        percent: internationalEquityFundData.top_ten[0].percent,
      },
      {
        name: internationalEquityFundData.top_ten[1].name,
        percent: internationalEquityFundData.top_ten[1].percent,
      },
      {
        name: internationalEquityFundData.top_ten[2].name,
        percent: internationalEquityFundData.top_ten[2].percent,
      },
      {
        name: internationalEquityFundData.top_ten[3].name,
        percent: internationalEquityFundData.top_ten[3].percent,
      },
      {
        name: internationalEquityFundData.top_ten[4].name,
        percent: internationalEquityFundData.top_ten[4].percent,
      },
      {
        name: internationalEquityFundData.top_ten[5].name,
        percent: internationalEquityFundData.top_ten[5].percent,
      },
      {
        name: internationalEquityFundData.top_ten[6].name,
        percent: internationalEquityFundData.top_ten[6].percent,
      },
      {
        name: internationalEquityFundData.top_ten[7].name,
        percent: internationalEquityFundData.top_ten[7].percent,
      },
      {
        name: internationalEquityFundData.top_ten[8].name,
        percent: internationalEquityFundData.top_ten[8].percent,
      },
      {
        name: internationalEquityFundData.top_ten[9].name,
        percent: internationalEquityFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: internationalEquityFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/international-equity.pdf',
    sectorWeightingsTitle: 'Geographic Allocation',
    sectorWeightings: [
      {
        name: internationalEquityFundData.sector_weightings[0].name,
        percent: internationalEquityFundData.sector_weightings[0].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[1].name,
        percent: internationalEquityFundData.sector_weightings[1].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[2].name,
        percent: internationalEquityFundData.sector_weightings[2].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[3].name,
        percent: internationalEquityFundData.sector_weightings[3].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[4].name,
        percent: internationalEquityFundData.sector_weightings[4].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[5].name,
        percent: internationalEquityFundData.sector_weightings[5].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[6].name,
        percent: internationalEquityFundData.sector_weightings[6].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[7].name,
        percent: internationalEquityFundData.sector_weightings[7].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[8].name,
        percent: internationalEquityFundData.sector_weightings[8].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[9].name,
        percent: internationalEquityFundData.sector_weightings[9].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[10].name,
        percent: internationalEquityFundData.sector_weightings[10].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[11].name,
        percent: internationalEquityFundData.sector_weightings[11].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[12].name,
        percent: internationalEquityFundData.sector_weightings[12].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[13].name,
        percent: internationalEquityFundData.sector_weightings[13].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[14].name,
        percent: internationalEquityFundData.sector_weightings[14].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[15].name,
        percent: internationalEquityFundData.sector_weightings[15].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[16].name,
        percent: internationalEquityFundData.sector_weightings[16].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[17].name,
        percent: internationalEquityFundData.sector_weightings[17].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[18].name,
        percent: internationalEquityFundData.sector_weightings[18].percent,
      },
      {
        name: internationalEquityFundData.sector_weightings[19].name,
        percent: internationalEquityFundData.sector_weightings[19].percent,
      },
    ],
  },
  // /////////////////////////////////////////////////////////
  internationalGrowthFund: {
    pageTitle: `${internationalGrowthFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'FIAM LLC, a Fidelity Investments Company',
    objectiveFocus: (<>The Portfolio primarily invests in common stocks of companies with growth potential which are domiciled or trade primarily on exchanges outside the United States, including emerging markets. Normally, the Portfolio will invest in a core group of 60&#8211;100 equity securities. These companies may be of any size. The objective is long&#45;term growth of capital.</>),
    assetClass: 'International Stocks',
    style: [
      'Growth',
      'Overseas investments can pose more risks than domestic investments. Unit values are subject to fluctuations in foreign stock markets, currency values, interest rates, government regulations and political conditions. The Portfolio may hold fewer securities than other diversified portfolios because of its focused investment strategy. Holding fewer securities increases the risk that the value of the Portfolio could go down because of poor performance of a single investment.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>07&#45;31&#45;2001</>),
    firstAvailableVar: (<>07&#45;31&#45;2001</>),
    firstAvailableLife: (<>07&#45;31&#45;2001</>),
    netAssets: internationalGrowthFundData.net_assets,
    topTen: [
      {
        name: internationalGrowthFundData.top_ten[0].name,
        percent: internationalGrowthFundData.top_ten[0].percent,
      },
      {
        name: internationalGrowthFundData.top_ten[1].name,
        percent: internationalGrowthFundData.top_ten[1].percent,
      },
      {
        name: internationalGrowthFundData.top_ten[2].name,
        percent: internationalGrowthFundData.top_ten[2].percent,
      },
      {
        name: internationalGrowthFundData.top_ten[3].name,
        percent: internationalGrowthFundData.top_ten[3].percent,
      },
      {
        name: internationalGrowthFundData.top_ten[4].name,
        percent: internationalGrowthFundData.top_ten[4].percent,
      },
      {
        name: internationalGrowthFundData.top_ten[5].name,
        percent: internationalGrowthFundData.top_ten[5].percent,
      },
      {
        name: internationalGrowthFundData.top_ten[6].name,
        percent: internationalGrowthFundData.top_ten[6].percent,
      },
      {
        name: internationalGrowthFundData.top_ten[7].name,
        percent: internationalGrowthFundData.top_ten[7].percent,
      },
      {
        name: internationalGrowthFundData.top_ten[8].name,
        percent: internationalGrowthFundData.top_ten[8].percent,
      },
      {
        name: internationalGrowthFundData.top_ten[9].name,
        percent: internationalGrowthFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: internationalGrowthFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/international-growth.pdf',
    sectorWeightingsTitle: 'Geographic Allocation',
    sectorWeightings: [
      {
        name: internationalGrowthFundData.sector_weightings[0].name,
        percent: internationalGrowthFundData.sector_weightings[0].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[1].name,
        percent: internationalGrowthFundData.sector_weightings[1].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[2].name,
        percent: internationalGrowthFundData.sector_weightings[2].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[3].name,
        percent: internationalGrowthFundData.sector_weightings[3].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[4].name,
        percent: internationalGrowthFundData.sector_weightings[4].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[5].name,
        percent: internationalGrowthFundData.sector_weightings[5].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[6].name,
        percent: internationalGrowthFundData.sector_weightings[6].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[7].name,
        percent: internationalGrowthFundData.sector_weightings[7].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[8].name,
        percent: internationalGrowthFundData.sector_weightings[8].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[9].name,
        percent: internationalGrowthFundData.sector_weightings[9].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[10].name,
        percent: internationalGrowthFundData.sector_weightings[10].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[11].name,
        percent: internationalGrowthFundData.sector_weightings[11].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[12].name,
        percent: internationalGrowthFundData.sector_weightings[12].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[13].name,
        percent: internationalGrowthFundData.sector_weightings[13].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[14].name,
        percent: internationalGrowthFundData.sector_weightings[14].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[15].name,
        percent: internationalGrowthFundData.sector_weightings[15].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[16].name,
        percent: internationalGrowthFundData.sector_weightings[16].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[17].name,
        percent: internationalGrowthFundData.sector_weightings[17].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[18].name,
        percent: internationalGrowthFundData.sector_weightings[18].percent,
      },
      {
        name: internationalGrowthFundData.sector_weightings[19].name,
        percent: internationalGrowthFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ////////////////////////////////////////////////////////////////
  largeCapBlendFund: {
    pageTitle: `${largeCapBlendFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'J.P. Morgan Investment Management, Inc.',
    objectiveFocus: (<>Invests primarily in a core group of 20&#8211;30 equity securities and American Depositary Receipts (ADRs). Seeks stocks of good businesses selling at value prices. The objective is to seek long&#45;term growth of capital and income.</>),
    assetClass: (<>Large&#45;Cap Stocks</>),
    style: [
      'Value',
      'Funds with a limited number of holdings may be more greatly affected by any single event or market development than funds that include more holdings.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: largeCapBlendFundData.net_assets,
    topTen: [
      {
        name: largeCapBlendFundData.top_ten[0].name,
        percent: largeCapBlendFundData.top_ten[0].percent,
      },
      {
        name: largeCapBlendFundData.top_ten[1].name,
        percent: largeCapBlendFundData.top_ten[1].percent,
      },
      {
        name: largeCapBlendFundData.top_ten[2].name,
        percent: largeCapBlendFundData.top_ten[2].percent,
      },
      {
        name: largeCapBlendFundData.top_ten[3].name,
        percent: largeCapBlendFundData.top_ten[3].percent,
      },
      {
        name: largeCapBlendFundData.top_ten[4].name,
        percent: largeCapBlendFundData.top_ten[4].percent,
      },
      {
        name: largeCapBlendFundData.top_ten[5].name,
        percent: largeCapBlendFundData.top_ten[5].percent,
      },
      {
        name: largeCapBlendFundData.top_ten[6].name,
        percent: largeCapBlendFundData.top_ten[6].percent,
      },
      {
        name: largeCapBlendFundData.top_ten[7].name,
        percent: largeCapBlendFundData.top_ten[7].percent,
      },
      {
        name: largeCapBlendFundData.top_ten[8].name,
        percent: largeCapBlendFundData.top_ten[8].percent,
      },
      {
        name: largeCapBlendFundData.top_ten[9].name,
        percent: largeCapBlendFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: largeCapBlendFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/large-cap-blend.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: largeCapBlendFundData.sector_weightings[0].name,
        percent: largeCapBlendFundData.sector_weightings[0].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[1].name,
        percent: largeCapBlendFundData.sector_weightings[1].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[2].name,
        percent: largeCapBlendFundData.sector_weightings[2].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[3].name,
        percent: largeCapBlendFundData.sector_weightings[3].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[4].name,
        percent: largeCapBlendFundData.sector_weightings[4].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[5].name,
        percent: largeCapBlendFundData.sector_weightings[5].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[6].name,
        percent: largeCapBlendFundData.sector_weightings[6].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[7].name,
        percent: largeCapBlendFundData.sector_weightings[7].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[8].name,
        percent: largeCapBlendFundData.sector_weightings[8].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[9].name,
        percent: largeCapBlendFundData.sector_weightings[9].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[10].name,
        percent: largeCapBlendFundData.sector_weightings[10].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[11].name,
        percent: largeCapBlendFundData.sector_weightings[11].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[12].name,
        percent: largeCapBlendFundData.sector_weightings[12].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[13].name,
        percent: largeCapBlendFundData.sector_weightings[13].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[14].name,
        percent: largeCapBlendFundData.sector_weightings[14].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[15].name,
        percent: largeCapBlendFundData.sector_weightings[15].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[16].name,
        percent: largeCapBlendFundData.sector_weightings[16].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[17].name,
        percent: largeCapBlendFundData.sector_weightings[17].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[18].name,
        percent: largeCapBlendFundData.sector_weightings[18].percent,
      },
      {
        name: largeCapBlendFundData.sector_weightings[19].name,
        percent: largeCapBlendFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ///////////////////////////////////////////////////////
  largeCapCoreStockFund: {
    pageTitle: `${largeCapCoreStockFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'J.P. Morgan Investment Management, Inc.',
    objectiveFocus: (<>Invests in the stocks of large capitalization companies that may include both growth and value stocks, and may represent companies across all market sectors. The objective is long&#45;term growth of capital and income.</>),
    assetClass: (<>Large&#45;Cap Stocks</>),
    style: ['Blend'],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>05&#45;03&#45;1994</>),
    firstAvailableVar: (<>05&#45;03&#45;1994</>),
    firstAvailableLife: (<>05&#45;03&#45;1994</>),
    netAssets: largeCapCoreStockFundData.net_assets,
    topTen: [
      {
        name: largeCapCoreStockFundData.top_ten[0].name,
        percent: largeCapCoreStockFundData.top_ten[0].percent,
      },
      {
        name: largeCapCoreStockFundData.top_ten[1].name,
        percent: largeCapCoreStockFundData.top_ten[1].percent,
      },
      {
        name: largeCapCoreStockFundData.top_ten[2].name,
        percent: largeCapCoreStockFundData.top_ten[2].percent,
      },
      {
        name: largeCapCoreStockFundData.top_ten[3].name,
        percent: largeCapCoreStockFundData.top_ten[3].percent,
      },
      {
        name: largeCapCoreStockFundData.top_ten[4].name,
        percent: largeCapCoreStockFundData.top_ten[4].percent,
      },
      {
        name: largeCapCoreStockFundData.top_ten[5].name,
        percent: largeCapCoreStockFundData.top_ten[5].percent,
      },
      {
        name: largeCapCoreStockFundData.top_ten[6].name,
        percent: largeCapCoreStockFundData.top_ten[6].percent,
      },
      {
        name: largeCapCoreStockFundData.top_ten[7].name,
        percent: largeCapCoreStockFundData.top_ten[7].percent,
      },
      {
        name: largeCapCoreStockFundData.top_ten[8].name,
        percent: largeCapCoreStockFundData.top_ten[8].percent,
      },
      {
        name: largeCapCoreStockFundData.top_ten[9].name,
        percent: largeCapCoreStockFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: largeCapCoreStockFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/large-cap-core-stock.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: largeCapCoreStockFundData.sector_weightings[0].name,
        percent: largeCapCoreStockFundData.sector_weightings[0].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[1].name,
        percent: largeCapCoreStockFundData.sector_weightings[1].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[2].name,
        percent: largeCapCoreStockFundData.sector_weightings[2].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[3].name,
        percent: largeCapCoreStockFundData.sector_weightings[3].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[4].name,
        percent: largeCapCoreStockFundData.sector_weightings[4].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[5].name,
        percent: largeCapCoreStockFundData.sector_weightings[5].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[6].name,
        percent: largeCapCoreStockFundData.sector_weightings[6].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[7].name,
        percent: largeCapCoreStockFundData.sector_weightings[7].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[8].name,
        percent: largeCapCoreStockFundData.sector_weightings[8].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[9].name,
        percent: largeCapCoreStockFundData.sector_weightings[9].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[10].name,
        percent: largeCapCoreStockFundData.sector_weightings[10].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[11].name,
        percent: largeCapCoreStockFundData.sector_weightings[11].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[12].name,
        percent: largeCapCoreStockFundData.sector_weightings[12].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[13].name,
        percent: largeCapCoreStockFundData.sector_weightings[13].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[14].name,
        percent: largeCapCoreStockFundData.sector_weightings[14].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[15].name,
        percent: largeCapCoreStockFundData.sector_weightings[15].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[16].name,
        percent: largeCapCoreStockFundData.sector_weightings[16].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[17].name,
        percent: largeCapCoreStockFundData.sector_weightings[17].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[18].name,
        percent: largeCapCoreStockFundData.sector_weightings[18].percent,
      },
      {
        name: largeCapCoreStockFundData.sector_weightings[19].name,
        percent: largeCapCoreStockFundData.sector_weightings[19].percent,
      },
    ],
    // no sector weightings or geographic allocation for this page
  },
  // //////////////////////////////////////////////////////////////////
  largeCompanyValueFund: {
    pageTitle: `${largeCompanyValueFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'American Century Investment Management, Inc.',
    objectiveFocus: 'Invests primarily in larger companies believed to be undervalued at the time of purchase. The objective is to seek long-term capital growth. Income is a secondary objective',
    assetClass: (<>Large&#45;Cap Stocks</>),
    style: ['Value'],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: largeCompanyValueFundData.net_assets,
    topTen: [
      {
        name: largeCompanyValueFundData.top_ten[0].name,
        percent: largeCompanyValueFundData.top_ten[0].percent,
      },
      {
        name: largeCompanyValueFundData.top_ten[1].name,
        percent: largeCompanyValueFundData.top_ten[1].percent,
      },
      {
        name: largeCompanyValueFundData.top_ten[2].name,
        percent: largeCompanyValueFundData.top_ten[2].percent,
      },
      {
        name: largeCompanyValueFundData.top_ten[3].name,
        percent: largeCompanyValueFundData.top_ten[3].percent,
      },
      {
        name: largeCompanyValueFundData.top_ten[4].name,
        percent: largeCompanyValueFundData.top_ten[4].percent,
      },
      {
        name: largeCompanyValueFundData.top_ten[5].name,
        percent: largeCompanyValueFundData.top_ten[5].percent,
      },
      {
        name: largeCompanyValueFundData.top_ten[6].name,
        percent: largeCompanyValueFundData.top_ten[6].percent,
      },
      {
        name: largeCompanyValueFundData.top_ten[7].name,
        percent: largeCompanyValueFundData.top_ten[7].percent,
      },
      {
        name: largeCompanyValueFundData.top_ten[8].name,
        percent: largeCompanyValueFundData.top_ten[8].percent,
      },
      {
        name: largeCompanyValueFundData.top_ten[9].name,
        percent: largeCompanyValueFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: largeCompanyValueFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/large-company-value.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: largeCompanyValueFundData.sector_weightings[0].name,
        percent: largeCompanyValueFundData.sector_weightings[0].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[1].name,
        percent: largeCompanyValueFundData.sector_weightings[1].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[2].name,
        percent: largeCompanyValueFundData.sector_weightings[2].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[3].name,
        percent: largeCompanyValueFundData.sector_weightings[3].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[4].name,
        percent: largeCompanyValueFundData.sector_weightings[4].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[5].name,
        percent: largeCompanyValueFundData.sector_weightings[5].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[6].name,
        percent: largeCompanyValueFundData.sector_weightings[6].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[7].name,
        percent: largeCompanyValueFundData.sector_weightings[7].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[8].name,
        percent: largeCompanyValueFundData.sector_weightings[8].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[9].name,
        percent: largeCompanyValueFundData.sector_weightings[9].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[10].name,
        percent: largeCompanyValueFundData.sector_weightings[10].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[11].name,
        percent: largeCompanyValueFundData.sector_weightings[11].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[12].name,
        percent: largeCompanyValueFundData.sector_weightings[12].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[13].name,
        percent: largeCompanyValueFundData.sector_weightings[13].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[14].name,
        percent: largeCompanyValueFundData.sector_weightings[14].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[15].name,
        percent: largeCompanyValueFundData.sector_weightings[15].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[16].name,
        percent: largeCompanyValueFundData.sector_weightings[16].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[17].name,
        percent: largeCompanyValueFundData.sector_weightings[17].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[18].name,
        percent: largeCompanyValueFundData.sector_weightings[18].percent,
      },
      {
        name: largeCompanyValueFundData.sector_weightings[19].name,
        percent: largeCompanyValueFundData.sector_weightings[19].percent,
      },
    ],
  },
  // /////////////////////////////////////////////////////////////////
  longTermUsGovernmentBondFund: {
    pageTitle: `${longTermUsGovernmentBondFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'Pacific Investment Management Company, LLC',
    objectiveFocus: (<>Normally invests at least 80&#37; of its net assets in a diversified portfolio of fixed income securities that are issued or guaranteed by the U.S. Government, its agencies or government&#45;sponsored enterprises and derivatives designed to replicate such securities. The objective is to seek maximum total return, consistent with preservation of capital and prudent investment management.</>),
    assetClass: 'Bond',
    style: [
      'High Credit Quality, Extensive Interest Rate Sensitivity',
      (<>Return of principal is not guaranteed. Bond funds have the same interest rate, inflation and credit risks that are associated with the underlying bonds owned by the Fund. When interest rates rise, bond prices fall. With a fixed income fund, when interest rates rise, the value of the fund&#39;s existing bonds drops, which could negatively affect overall fund performance.</>),
      'The Portfolio may use derivative instruments as part of it investment strategy. Use of these instruments may involve certain risks such as leverage risk, liquidity risk, interest rate risk, market risk, credit risks, management risk and the risk that the Portfolio could not close out a position when it would be more advantageous to do so. Portfolios investing in derivatives could lose more than the principal amount invested in those instruments.',
      (<>The potential leverage created by use of derivatives may cause the Portfolio to be more sensitive to interest rate movements and thus more volatile than other long&#45;term U.S. government bond funds that do not use derivatives.</>),
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: longTermUsGovernmentBondFundData.net_assets,
    topTen: [
      {
        name: longTermUsGovernmentBondFundData.top_ten[0].name,
        percent: longTermUsGovernmentBondFundData.top_ten[0].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.top_ten[1].name,
        percent: longTermUsGovernmentBondFundData.top_ten[1].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.top_ten[2].name,
        percent: longTermUsGovernmentBondFundData.top_ten[2].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.top_ten[3].name,
        percent: longTermUsGovernmentBondFundData.top_ten[3].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.top_ten[4].name,
        percent: longTermUsGovernmentBondFundData.top_ten[4].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.top_ten[5].name,
        percent: longTermUsGovernmentBondFundData.top_ten[5].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.top_ten[6].name,
        percent: longTermUsGovernmentBondFundData.top_ten[6].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.top_ten[7].name,
        percent: longTermUsGovernmentBondFundData.top_ten[7].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.top_ten[8].name,
        percent: longTermUsGovernmentBondFundData.top_ten[8].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.top_ten[9].name,
        percent: longTermUsGovernmentBondFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: longTermUsGovernmentBondFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/long-term-us-government-bond.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[0].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[0].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[1].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[1].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[2].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[2].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[3].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[3].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[4].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[4].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[5].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[5].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[6].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[6].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[7].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[7].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[8].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[8].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[9].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[9].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[10].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[10].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[11].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[11].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[12].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[12].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[13].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[13].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[14].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[14].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[15].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[15].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[16].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[16].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[17].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[17].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[18].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[18].percent,
      },
      {
        name: longTermUsGovernmentBondFundData.sector_weightings[19].name,
        percent: longTermUsGovernmentBondFundData.sector_weightings[19].percent,
      },
    ],
  },
  // /////////////////////////////////////////////////////////////////
  midCapGrowthStockFund: {
    pageTitle: `${midCapGrowthStockFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'J.P. Morgan Investment Management, Inc.',
    objectiveFocus: (<>Invests in stocks of mid&#45;sized companies selected for their above&#45;average growth potential. The objective is long&#45;term capital growth.</>),
    assetClass: (<>Mid&#45;Cap Stocks</>),
    style: [
      'Growth',
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks.',
      'Investing in medium company stocks involves a greater degree of risk than investing in large company stocks.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>12&#45;12&#45;1990</>),
    firstAvailableVar: (<>12&#45;03&#45;1990</>),
    firstAvailableLife: (<>05&#45;03&#45;1994</>),
    netAssets: midCapGrowthStockFundData.net_assets,
    topTen: [
      {
        name: midCapGrowthStockFundData.top_ten[0].name,
        percent: midCapGrowthStockFundData.top_ten[0].percent,
      },
      {
        name: midCapGrowthStockFundData.top_ten[1].name,
        percent: midCapGrowthStockFundData.top_ten[1].percent,
      },
      {
        name: midCapGrowthStockFundData.top_ten[2].name,
        percent: midCapGrowthStockFundData.top_ten[2].percent,
      },
      {
        name: midCapGrowthStockFundData.top_ten[3].name,
        percent: midCapGrowthStockFundData.top_ten[3].percent,
      },
      {
        name: midCapGrowthStockFundData.top_ten[4].name,
        percent: midCapGrowthStockFundData.top_ten[4].percent,
      },
      {
        name: midCapGrowthStockFundData.top_ten[5].name,
        percent: midCapGrowthStockFundData.top_ten[5].percent,
      },
      {
        name: midCapGrowthStockFundData.top_ten[6].name,
        percent: midCapGrowthStockFundData.top_ten[6].percent,
      },
      {
        name: midCapGrowthStockFundData.top_ten[7].name,
        percent: midCapGrowthStockFundData.top_ten[7].percent,
      },
      {
        name: midCapGrowthStockFundData.top_ten[8].name,
        percent: midCapGrowthStockFundData.top_ten[8].percent,
      },
      {
        name: midCapGrowthStockFundData.top_ten[9].name,
        percent: midCapGrowthStockFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: midCapGrowthStockFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/mid-cap-growth-stock.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: midCapGrowthStockFundData.sector_weightings[0].name,
        percent: midCapGrowthStockFundData.sector_weightings[0].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[1].name,
        percent: midCapGrowthStockFundData.sector_weightings[1].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[2].name,
        percent: midCapGrowthStockFundData.sector_weightings[2].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[3].name,
        percent: midCapGrowthStockFundData.sector_weightings[3].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[4].name,
        percent: midCapGrowthStockFundData.sector_weightings[4].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[5].name,
        percent: midCapGrowthStockFundData.sector_weightings[5].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[6].name,
        percent: midCapGrowthStockFundData.sector_weightings[6].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[7].name,
        percent: midCapGrowthStockFundData.sector_weightings[7].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[8].name,
        percent: midCapGrowthStockFundData.sector_weightings[8].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[9].name,
        percent: midCapGrowthStockFundData.sector_weightings[9].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[10].name,
        percent: midCapGrowthStockFundData.sector_weightings[10].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[11].name,
        percent: midCapGrowthStockFundData.sector_weightings[11].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[12].name,
        percent: midCapGrowthStockFundData.sector_weightings[12].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[13].name,
        percent: midCapGrowthStockFundData.sector_weightings[13].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[14].name,
        percent: midCapGrowthStockFundData.sector_weightings[14].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[15].name,
        percent: midCapGrowthStockFundData.sector_weightings[15].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[16].name,
        percent: midCapGrowthStockFundData.sector_weightings[16].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[17].name,
        percent: midCapGrowthStockFundData.sector_weightings[17].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[18].name,
        percent: midCapGrowthStockFundData.sector_weightings[18].percent,
      },
      {
        name: midCapGrowthStockFundData.sector_weightings[19].name,
        percent: midCapGrowthStockFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ///////////////////////////////////////////////////////////
  midCapValueFund: {
    pageTitle: `${midCapValueFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'American Century Investment Management, Inc.',
    objectiveFocus: 'Invests primarily in common stocks of medium sized companies that are determined through quantitative and fundamental research to be undervalued.',
    assetClass: (<>Mid&#45;Cap Stocks</>),
    style: ['Value'],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>05&#45;01&#45;2003</>),
    firstAvailableVar: (<>05&#45;01&#45;2003</>),
    firstAvailableLife: (<>05&#45;01&#45;2003</>),
    netAssets: midCapValueFundData.net_assets,
    topTen: [
      {
        name: midCapValueFundData.top_ten[0].name,
        percent: midCapValueFundData.top_ten[0].percent,
      },
      {
        name: midCapValueFundData.top_ten[1].name,
        percent: midCapValueFundData.top_ten[1].percent,
      },
      {
        name: midCapValueFundData.top_ten[2].name,
        percent: midCapValueFundData.top_ten[2].percent,
      },
      {
        name: midCapValueFundData.top_ten[3].name,
        percent: midCapValueFundData.top_ten[3].percent,
      },
      {
        name: midCapValueFundData.top_ten[4].name,
        percent: midCapValueFundData.top_ten[4].percent,
      },
      {
        name: midCapValueFundData.top_ten[5].name,
        percent: midCapValueFundData.top_ten[5].percent,
      },
      {
        name: midCapValueFundData.top_ten[6].name,
        percent: midCapValueFundData.top_ten[6].percent,
      },
      {
        name: midCapValueFundData.top_ten[7].name,
        percent: midCapValueFundData.top_ten[7].percent,
      },
      {
        name: midCapValueFundData.top_ten[8].name,
        percent: midCapValueFundData.top_ten[8].percent,
      },
      {
        name: midCapValueFundData.top_ten[9].name,
        percent: midCapValueFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: midCapValueFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/mid-cap-value.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: midCapValueFundData.sector_weightings[0].name,
        percent: midCapValueFundData.sector_weightings[0].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[1].name,
        percent: midCapValueFundData.sector_weightings[1].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[2].name,
        percent: midCapValueFundData.sector_weightings[2].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[3].name,
        percent: midCapValueFundData.sector_weightings[3].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[4].name,
        percent: midCapValueFundData.sector_weightings[4].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[5].name,
        percent: midCapValueFundData.sector_weightings[5].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[6].name,
        percent: midCapValueFundData.sector_weightings[6].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[7].name,
        percent: midCapValueFundData.sector_weightings[7].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[8].name,
        percent: midCapValueFundData.sector_weightings[8].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[9].name,
        percent: midCapValueFundData.sector_weightings[9].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[10].name,
        percent: midCapValueFundData.sector_weightings[10].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[11].name,
        percent: midCapValueFundData.sector_weightings[11].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[12].name,
        percent: midCapValueFundData.sector_weightings[12].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[13].name,
        percent: midCapValueFundData.sector_weightings[13].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[14].name,
        percent: midCapValueFundData.sector_weightings[14].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[15].name,
        percent: midCapValueFundData.sector_weightings[15].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[16].name,
        percent: midCapValueFundData.sector_weightings[16].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[17].name,
        percent: midCapValueFundData.sector_weightings[17].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[18].name,
        percent: midCapValueFundData.sector_weightings[18].percent,
      },
      {
        name: midCapValueFundData.sector_weightings[19].name,
        percent: midCapValueFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ///////////////////////////////////////////////////////////
  multiSectorBondFund: {
    pageTitle: `${multiSectorBondFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'Pacific Investment Management Company, LLC',
    objectiveFocus: (<>Normally invests at least 80&#37; of its net assets in a diversified portfolio of fixed income instruments of varying maturities, which may be represented by forwards or derivatives. The objective is to seek maximum total return, consistent with prudent investment management.</>),
    assetClass: 'Bond',
    style: [
      'Domestic and International Bonds',
      (<>Return of principal is not guaranteed. Bonds and other debt obligations are affected by changes in interest rates, inflation risk and the creditworthiness of their issuers. When interest rates rise, bond prices fall. With a fixed income fund, when interest rates rise, the value of the fund&#39;s existing bonds drops, which could negatively affect overall fund performance.</>),
      'In contrast to owning individual bonds, there are ongoing fees and expenses associated with owning shares of bond funds. High yield bonds generally have greater price swings and higher default risks than investment grade bonds.',
      (<>Investors should be aware of the risks of investments in foreign securities, particularly investments in securities of companies in developing
        nations. These include risks of currency fluctuation, of political and economic instability and of less well&#45;developed government
        supervision and regulation of business and industry practices, as well as differences in accounting standards.</>),
      'The Portfolio may use derivative instruments as part of its investment strategy. Use of these instruments may involve certain risks such as leverage risk, liquidity risk, interest rate risk, market risk, credit risks, management risk and the risk that the Portfolio could not close out a position when it would be more advantageous to do so. Portfolios investing in derivatives could lose more than the principal amount invested in those instruments.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: multiSectorBondFundData.net_assets,
    topTen: [
      {
        name: multiSectorBondFundData.top_ten[0].name,
        percent: multiSectorBondFundData.top_ten[0].percent,
      },
      {
        name: multiSectorBondFundData.top_ten[1].name,
        percent: multiSectorBondFundData.top_ten[1].percent,
      },
      {
        name: multiSectorBondFundData.top_ten[2].name,
        percent: multiSectorBondFundData.top_ten[2].percent,
      },
      {
        name: multiSectorBondFundData.top_ten[3].name,
        percent: multiSectorBondFundData.top_ten[3].percent,
      },
      {
        name: multiSectorBondFundData.top_ten[4].name,
        percent: multiSectorBondFundData.top_ten[4].percent,
      },
      {
        name: multiSectorBondFundData.top_ten[5].name,
        percent: multiSectorBondFundData.top_ten[5].percent,
      },
      {
        name: multiSectorBondFundData.top_ten[6].name,
        percent: multiSectorBondFundData.top_ten[6].percent,
      },
      {
        name: multiSectorBondFundData.top_ten[7].name,
        percent: multiSectorBondFundData.top_ten[7].percent,
      },
      {
        name: multiSectorBondFundData.top_ten[8].name,
        percent: multiSectorBondFundData.top_ten[8].percent,
      },
      {
        name: multiSectorBondFundData.top_ten[9].name,
        percent: multiSectorBondFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: multiSectorBondFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/multi-sector-bond.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: multiSectorBondFundData.sector_weightings[0].name,
        percent: multiSectorBondFundData.sector_weightings[0].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[1].name,
        percent: multiSectorBondFundData.sector_weightings[1].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[2].name,
        percent: multiSectorBondFundData.sector_weightings[2].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[3].name,
        percent: multiSectorBondFundData.sector_weightings[3].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[4].name,
        percent: multiSectorBondFundData.sector_weightings[4].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[5].name,
        percent: multiSectorBondFundData.sector_weightings[5].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[6].name,
        percent: multiSectorBondFundData.sector_weightings[6].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[7].name,
        percent: multiSectorBondFundData.sector_weightings[7].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[8].name,
        percent: multiSectorBondFundData.sector_weightings[8].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[9].name,
        percent: multiSectorBondFundData.sector_weightings[9].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[10].name,
        percent: multiSectorBondFundData.sector_weightings[10].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[11].name,
        percent: multiSectorBondFundData.sector_weightings[11].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[12].name,
        percent: multiSectorBondFundData.sector_weightings[12].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[13].name,
        percent: multiSectorBondFundData.sector_weightings[13].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[14].name,
        percent: multiSectorBondFundData.sector_weightings[14].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[15].name,
        percent: multiSectorBondFundData.sector_weightings[15].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[16].name,
        percent: multiSectorBondFundData.sector_weightings[16].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[17].name,
        percent: multiSectorBondFundData.sector_weightings[17].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[18].name,
        percent: multiSectorBondFundData.sector_weightings[18].percent,
      },
      {
        name: multiSectorBondFundData.sector_weightings[19].name,
        percent: multiSectorBondFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ///////////////////////////////////////////////////////////
  researchInternationalCoreFund: {
    pageTitle: `${researchInternationalCoreFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'Massachusetts Financial Services Company',
    objectiveFocus: 'The Portfolio primarily invests in foreign equity securities, including emerging market equity securities. The objective is capital appreciation.',
    assetClass: 'International Stocks',
    style: [
      'Blend',
      (<>Investors should be aware of the risks of investments in foreign securities, particularly investments in securities of companies in developing
        nations. These include the risks of currency fluctuation, of political and economic instability and of less well&#45;developed government
        supervision and regulation of business and industry practices, as well as differences in accounting standards.</>),
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks. Investing in medium company stocks involves a greater degree of risk than investing in large company stocks.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: researchInternationalCoreFundData.net_assets,
    topTen: [
      {
        name: researchInternationalCoreFundData.top_ten[0].name,
        percent: researchInternationalCoreFundData.top_ten[0].percent,
      },
      {
        name: researchInternationalCoreFundData.top_ten[1].name,
        percent: researchInternationalCoreFundData.top_ten[1].percent,
      },
      {
        name: researchInternationalCoreFundData.top_ten[2].name,
        percent: researchInternationalCoreFundData.top_ten[2].percent,
      },
      {
        name: researchInternationalCoreFundData.top_ten[3].name,
        percent: researchInternationalCoreFundData.top_ten[3].percent,
      },
      {
        name: researchInternationalCoreFundData.top_ten[4].name,
        percent: researchInternationalCoreFundData.top_ten[4].percent,
      },
      {
        name: researchInternationalCoreFundData.top_ten[5].name,
        percent: researchInternationalCoreFundData.top_ten[5].percent,
      },
      {
        name: researchInternationalCoreFundData.top_ten[6].name,
        percent: researchInternationalCoreFundData.top_ten[6].percent,
      },
      {
        name: researchInternationalCoreFundData.top_ten[7].name,
        percent: researchInternationalCoreFundData.top_ten[7].percent,
      },
      {
        name: researchInternationalCoreFundData.top_ten[8].name,
        percent: researchInternationalCoreFundData.top_ten[8].percent,
      },
      {
        name: researchInternationalCoreFundData.top_ten[9].name,
        percent: researchInternationalCoreFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: researchInternationalCoreFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/research-international-core.pdf',
    sectorWeightingsTitle: 'Geographic Allocation',
    sectorWeightings: [
      {
        name: researchInternationalCoreFundData.sector_weightings[0].name,
        percent: researchInternationalCoreFundData.sector_weightings[0].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[1].name,
        percent: researchInternationalCoreFundData.sector_weightings[1].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[2].name,
        percent: researchInternationalCoreFundData.sector_weightings[2].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[3].name,
        percent: researchInternationalCoreFundData.sector_weightings[3].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[4].name,
        percent: researchInternationalCoreFundData.sector_weightings[4].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[5].name,
        percent: researchInternationalCoreFundData.sector_weightings[5].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[6].name,
        percent: researchInternationalCoreFundData.sector_weightings[6].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[7].name,
        percent: researchInternationalCoreFundData.sector_weightings[7].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[8].name,
        percent: researchInternationalCoreFundData.sector_weightings[8].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[9].name,
        percent: researchInternationalCoreFundData.sector_weightings[9].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[10].name,
        percent: researchInternationalCoreFundData.sector_weightings[10].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[11].name,
        percent: researchInternationalCoreFundData.sector_weightings[11].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[12].name,
        percent: researchInternationalCoreFundData.sector_weightings[12].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[13].name,
        percent: researchInternationalCoreFundData.sector_weightings[13].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[14].name,
        percent: researchInternationalCoreFundData.sector_weightings[14].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[15].name,
        percent: researchInternationalCoreFundData.sector_weightings[15].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[16].name,
        percent: researchInternationalCoreFundData.sector_weightings[16].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[17].name,
        percent: researchInternationalCoreFundData.sector_weightings[17].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[18].name,
        percent: researchInternationalCoreFundData.sector_weightings[18].percent,
      },
      {
        name: researchInternationalCoreFundData.sector_weightings[19].name,
        percent: researchInternationalCoreFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ///////////////////////////////////////////////////////////
  selectBondFund: {
    pageTitle: `${selectBondFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'Allspring Global Investments, LLC',
    objectiveFocus: (<>Invests primarily in investment grade corporate, U.S. Treasury and government agency bonds and mortgage&#45; and asset&#45;backed securities. The objective is to provide as high a level of total return as is consistent with prudent investment risk. A secondary objective is preservation of capital.</>),
    assetClass: 'Bond',
    style: [
      'High Credit Quality, Moderate Interest Rate',
      'Bonds and other debt obligations are affected by changes in interest rates, inflation risk and the creditworthiness of their issuers. High yield bonds generally have greater price swings and higher default risks than investment grade bonds. Return of principal is not guaranteed. In contrast to owning individual bonds, there are ongoing fees and expenses associated with owning shares of bond funds.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>12&#45;31&#45;1981</>),
    firstAvailableVar: (<>07&#45;01&#45;1984</>),
    netAssets: selectBondFundData.net_assets,
    topTen: [
      {
        name: selectBondFundData.top_ten[0].name,
        percent: selectBondFundData.top_ten[0].percent,
      },
      {
        name: selectBondFundData.top_ten[1].name,
        percent: selectBondFundData.top_ten[1].percent,
      },
      {
        name: selectBondFundData.top_ten[2].name,
        percent: selectBondFundData.top_ten[2].percent,
      },
      {
        name: selectBondFundData.top_ten[3].name,
        percent: selectBondFundData.top_ten[3].percent,
      },
      {
        name: selectBondFundData.top_ten[4].name,
        percent: selectBondFundData.top_ten[4].percent,
      },
      {
        name: selectBondFundData.top_ten[5].name,
        percent: selectBondFundData.top_ten[5].percent,
      },
      {
        name: selectBondFundData.top_ten[6].name,
        percent: selectBondFundData.top_ten[6].percent,
      },
      {
        name: selectBondFundData.top_ten[7].name,
        percent: selectBondFundData.top_ten[7].percent,
      },
      {
        name: selectBondFundData.top_ten[8].name,
        percent: selectBondFundData.top_ten[8].percent,
      },
      {
        name: selectBondFundData.top_ten[9].name,
        percent: selectBondFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: selectBondFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/select-bond.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: selectBondFundData.sector_weightings[0].name,
        percent: selectBondFundData.sector_weightings[0].percent,
      },
      {
        name: selectBondFundData.sector_weightings[1].name,
        percent: selectBondFundData.sector_weightings[1].percent,
      },
      {
        name: selectBondFundData.sector_weightings[2].name,
        percent: selectBondFundData.sector_weightings[2].percent,
      },
      {
        name: selectBondFundData.sector_weightings[3].name,
        percent: selectBondFundData.sector_weightings[3].percent,
      },
      {
        name: selectBondFundData.sector_weightings[4].name,
        percent: selectBondFundData.sector_weightings[4].percent,
      },
      {
        name: selectBondFundData.sector_weightings[5].name,
        percent: selectBondFundData.sector_weightings[5].percent,
      },
      {
        name: selectBondFundData.sector_weightings[6].name,
        percent: selectBondFundData.sector_weightings[6].percent,
      },
      {
        name: selectBondFundData.sector_weightings[7].name,
        percent: selectBondFundData.sector_weightings[7].percent,
      },
      {
        name: selectBondFundData.sector_weightings[8].name,
        percent: selectBondFundData.sector_weightings[8].percent,
      },
      {
        name: selectBondFundData.sector_weightings[9].name,
        percent: selectBondFundData.sector_weightings[9].percent,
      },
      {
        name: selectBondFundData.sector_weightings[10].name,
        percent: selectBondFundData.sector_weightings[10].percent,
      },
      {
        name: selectBondFundData.sector_weightings[11].name,
        percent: selectBondFundData.sector_weightings[11].percent,
      },
      {
        name: selectBondFundData.sector_weightings[12].name,
        percent: selectBondFundData.sector_weightings[12].percent,
      },
      {
        name: selectBondFundData.sector_weightings[13].name,
        percent: selectBondFundData.sector_weightings[13].percent,
      },
      {
        name: selectBondFundData.sector_weightings[14].name,
        percent: selectBondFundData.sector_weightings[14].percent,
      },
      {
        name: selectBondFundData.sector_weightings[15].name,
        percent: selectBondFundData.sector_weightings[15].percent,
      },
      {
        name: selectBondFundData.sector_weightings[16].name,
        percent: selectBondFundData.sector_weightings[16].percent,
      },
      {
        name: selectBondFundData.sector_weightings[17].name,
        percent: selectBondFundData.sector_weightings[17].percent,
      },
      {
        name: selectBondFundData.sector_weightings[18].name,
        percent: selectBondFundData.sector_weightings[18].percent,
      },
      {
        name: selectBondFundData.sector_weightings[19].name,
        percent: selectBondFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ///////////////////////////////////////////////////////////
  shortTermBondFund: {
    pageTitle: `${shortTermBondFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'T. Rowe Price Associates, Inc.',
    objectiveFocus: (<>Normally invests at least 80&#37; of net assets in a diversified portfolio of investment grade debt securities. The primary investment objective of the Portfolio is to provide as high a level of current income as is consistent with prudent investment risk.</>),
    assetClass: 'Bond',
    style: [
      'High Credit Quality, Limited Interest Rate Sensitivity',
      (<>Return of principal is not guaranteed. Bonds and other debt obligations are affected by changes in interest rates, inflation risk and the creditworthiness of their issuers. When interest rates rise, bond prices fall. With a fixed income fund, when interest rates rise, the value of the fund&#39;s existing bonds drop, which could negatively affect overall fund performance.</>),
      'In contrast to owning individual bonds, there are ongoing fees and expenses associated with owning shares of bond funds. High yield bonds generally have greater price swings and higher default risks than investment grade bonds.',
      (<>Investors should be aware of the risks of investments in foreign securities, particularly investments in securities of companies in developing
        nations. These include the risks of currency fluctuation, of political and economic instability and of less well&#45;developed government
        supervision and regulation of business and industry practices, as well as differences in accounting standards.</>),
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;2007</>),
    firstAvailableVar: (<>04&#45;30&#45;2007</>),
    firstAvailableLife: (<>06&#45;30&#45;2011</>),
    netAssets: shortTermBondFundData.net_assets,
    topTen: [
      {
        name: shortTermBondFundData.top_ten[0].name,
        percent: shortTermBondFundData.top_ten[0].percent,
      },
      {
        name: shortTermBondFundData.top_ten[1].name,
        percent: shortTermBondFundData.top_ten[1].percent,
      },
      {
        name: shortTermBondFundData.top_ten[2].name,
        percent: shortTermBondFundData.top_ten[2].percent,
      },
      {
        name: shortTermBondFundData.top_ten[3].name,
        percent: shortTermBondFundData.top_ten[3].percent,
      },
      {
        name: shortTermBondFundData.top_ten[4].name,
        percent: shortTermBondFundData.top_ten[4].percent,
      },
      {
        name: shortTermBondFundData.top_ten[5].name,
        percent: shortTermBondFundData.top_ten[5].percent,
      },
      {
        name: shortTermBondFundData.top_ten[6].name,
        percent: shortTermBondFundData.top_ten[6].percent,
      },
      {
        name: shortTermBondFundData.top_ten[7].name,
        percent: shortTermBondFundData.top_ten[7].percent,
      },
      {
        name: shortTermBondFundData.top_ten[8].name,
        percent: shortTermBondFundData.top_ten[8].percent,
      },
      {
        name: shortTermBondFundData.top_ten[9].name,
        percent: shortTermBondFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: shortTermBondFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/short-term-bond.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: shortTermBondFundData.sector_weightings[0].name,
        percent: shortTermBondFundData.sector_weightings[0].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[1].name,
        percent: shortTermBondFundData.sector_weightings[1].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[2].name,
        percent: shortTermBondFundData.sector_weightings[2].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[3].name,
        percent: shortTermBondFundData.sector_weightings[3].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[4].name,
        percent: shortTermBondFundData.sector_weightings[4].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[5].name,
        percent: shortTermBondFundData.sector_weightings[5].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[6].name,
        percent: shortTermBondFundData.sector_weightings[6].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[7].name,
        percent: shortTermBondFundData.sector_weightings[7].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[8].name,
        percent: shortTermBondFundData.sector_weightings[8].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[9].name,
        percent: shortTermBondFundData.sector_weightings[9].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[10].name,
        percent: shortTermBondFundData.sector_weightings[10].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[11].name,
        percent: shortTermBondFundData.sector_weightings[11].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[12].name,
        percent: shortTermBondFundData.sector_weightings[12].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[13].name,
        percent: shortTermBondFundData.sector_weightings[13].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[14].name,
        percent: shortTermBondFundData.sector_weightings[14].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[15].name,
        percent: shortTermBondFundData.sector_weightings[15].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[16].name,
        percent: shortTermBondFundData.sector_weightings[16].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[17].name,
        percent: shortTermBondFundData.sector_weightings[17].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[18].name,
        percent: shortTermBondFundData.sector_weightings[18].percent,
      },
      {
        name: shortTermBondFundData.sector_weightings[19].name,
        percent: shortTermBondFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ///////////////////////////////////////////////////////////
  smallCapGrowthStockFund: {
    pageTitle: `${smallCapGrowthStockFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'J.P. Morgan Investment Management, Inc.',
    objectiveFocus: (<>Invests primarily in stocks of small capitalization and microcap U.S. companies selected for their above&#45;average growth potential. The objective is long&#45;term capital growth.</>),
    assetClass: (<>Small&#45;Cap Stocks</>),
    style: [
      'Growth',
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>04&#45;30&#45;1999</>),
    firstAvailableVar: (<>04&#45;30&#45;1999</>),
    firstAvailableLife: (<>04&#45;30&#45;1999</>),
    netAssets: smallCapGrowthStockFundData.net_assets,
    topTen: [
      {
        name: smallCapGrowthStockFundData.top_ten[0].name,
        percent: smallCapGrowthStockFundData.top_ten[0].percent,
      },
      {
        name: smallCapGrowthStockFundData.top_ten[1].name,
        percent: smallCapGrowthStockFundData.top_ten[1].percent,
      },
      {
        name: smallCapGrowthStockFundData.top_ten[2].name,
        percent: smallCapGrowthStockFundData.top_ten[2].percent,
      },
      {
        name: smallCapGrowthStockFundData.top_ten[3].name,
        percent: smallCapGrowthStockFundData.top_ten[3].percent,
      },
      {
        name: smallCapGrowthStockFundData.top_ten[4].name,
        percent: smallCapGrowthStockFundData.top_ten[4].percent,
      },
      {
        name: smallCapGrowthStockFundData.top_ten[5].name,
        percent: smallCapGrowthStockFundData.top_ten[5].percent,
      },
      {
        name: smallCapGrowthStockFundData.top_ten[6].name,
        percent: smallCapGrowthStockFundData.top_ten[6].percent,
      },
      {
        name: smallCapGrowthStockFundData.top_ten[7].name,
        percent: smallCapGrowthStockFundData.top_ten[7].percent,
      },
      {
        name: smallCapGrowthStockFundData.top_ten[8].name,
        percent: smallCapGrowthStockFundData.top_ten[8].percent,
      },
      {
        name: smallCapGrowthStockFundData.top_ten[9].name,
        percent: smallCapGrowthStockFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: smallCapGrowthStockFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/small-cap-growth-stock.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: smallCapGrowthStockFundData.sector_weightings[0].name,
        percent: smallCapGrowthStockFundData.sector_weightings[0].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[1].name,
        percent: smallCapGrowthStockFundData.sector_weightings[1].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[2].name,
        percent: smallCapGrowthStockFundData.sector_weightings[2].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[3].name,
        percent: smallCapGrowthStockFundData.sector_weightings[3].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[4].name,
        percent: smallCapGrowthStockFundData.sector_weightings[4].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[5].name,
        percent: smallCapGrowthStockFundData.sector_weightings[5].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[6].name,
        percent: smallCapGrowthStockFundData.sector_weightings[6].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[7].name,
        percent: smallCapGrowthStockFundData.sector_weightings[7].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[8].name,
        percent: smallCapGrowthStockFundData.sector_weightings[8].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[9].name,
        percent: smallCapGrowthStockFundData.sector_weightings[9].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[10].name,
        percent: smallCapGrowthStockFundData.sector_weightings[10].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[11].name,
        percent: smallCapGrowthStockFundData.sector_weightings[11].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[12].name,
        percent: smallCapGrowthStockFundData.sector_weightings[12].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[13].name,
        percent: smallCapGrowthStockFundData.sector_weightings[13].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[14].name,
        percent: smallCapGrowthStockFundData.sector_weightings[14].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[15].name,
        percent: smallCapGrowthStockFundData.sector_weightings[15].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[16].name,
        percent: smallCapGrowthStockFundData.sector_weightings[16].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[17].name,
        percent: smallCapGrowthStockFundData.sector_weightings[17].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[18].name,
        percent: smallCapGrowthStockFundData.sector_weightings[18].percent,
      },
      {
        name: smallCapGrowthStockFundData.sector_weightings[19].name,
        percent: smallCapGrowthStockFundData.sector_weightings[19].percent,
      },
    ],
  },
  // ///////////////////////////////////////////////////////////
  smallCapValueFund: {
    pageTitle: `${smallCapValueFundData.name} Fund`,
    advisor: 'Mason Street Advisors, LLC',
    subAdvisor: 'T. Rowe Price Investment Management, Inc.',
    objectiveFocus: (<>Invests primarily in the stocks of small capitalization companies whose current stock prices do not appear to adequately reflect their underlying value as measured by assets, earnings, cash flow, or business franchises. The objective is to seek long&#45;term capital growth.</>),
    assetClass: (<>Small&#45;Cap Stocks</>),
    style: [
      'Value',
      'Investing in small company stocks involves a greater degree of risk than investing in medium or large company stocks.',
    ],
    fundFactsDate: fundsDate,
    fundInceptionDate: (<>07&#45;31&#45;2001</>),
    firstAvailableVar: (<>07&#45;31&#45;2001</>),
    firstAvailableLife: (<>07&#45;31&#45;2001</>),
    netAssets: smallCapValueFundData.net_assets,
    topTen: [
      {
        name: smallCapValueFundData.top_ten[0].name,
        percent: smallCapValueFundData.top_ten[0].percent,
      },
      {
        name: smallCapValueFundData.top_ten[1].name,
        percent: smallCapValueFundData.top_ten[1].percent,
      },
      {
        name: smallCapValueFundData.top_ten[2].name,
        percent: smallCapValueFundData.top_ten[2].percent,
      },
      {
        name: smallCapValueFundData.top_ten[3].name,
        percent: smallCapValueFundData.top_ten[3].percent,
      },
      {
        name: smallCapValueFundData.top_ten[4].name,
        percent: smallCapValueFundData.top_ten[4].percent,
      },
      {
        name: smallCapValueFundData.top_ten[5].name,
        percent: smallCapValueFundData.top_ten[5].percent,
      },
      {
        name: smallCapValueFundData.top_ten[6].name,
        percent: smallCapValueFundData.top_ten[6].percent,
      },
      {
        name: smallCapValueFundData.top_ten[7].name,
        percent: smallCapValueFundData.top_ten[7].percent,
      },
      {
        name: smallCapValueFundData.top_ten[8].name,
        percent: smallCapValueFundData.top_ten[8].percent,
      },
      {
        name: smallCapValueFundData.top_ten[9].name,
        percent: smallCapValueFundData.top_ten[9].percent,
      },
    ],
    topTenTotal: smallCapValueFundData.top_ten_total,
    pdfLink: '/assets/pdf/portfolio-holdings/small-cap-value.pdf',
    sectorWeightingsTitle: 'Sector Weightings',
    sectorWeightings: [
      {
        name: smallCapValueFundData.sector_weightings[0].name,
        percent: smallCapValueFundData.sector_weightings[0].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[1].name,
        percent: smallCapValueFundData.sector_weightings[1].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[2].name,
        percent: smallCapValueFundData.sector_weightings[2].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[3].name,
        percent: smallCapValueFundData.sector_weightings[3].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[4].name,
        percent: smallCapValueFundData.sector_weightings[4].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[5].name,
        percent: smallCapValueFundData.sector_weightings[5].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[6].name,
        percent: smallCapValueFundData.sector_weightings[6].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[7].name,
        percent: smallCapValueFundData.sector_weightings[7].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[8].name,
        percent: smallCapValueFundData.sector_weightings[8].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[9].name,
        percent: smallCapValueFundData.sector_weightings[9].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[10].name,
        percent: smallCapValueFundData.sector_weightings[10].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[11].name,
        percent: smallCapValueFundData.sector_weightings[11].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[12].name,
        percent: smallCapValueFundData.sector_weightings[12].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[13].name,
        percent: smallCapValueFundData.sector_weightings[13].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[14].name,
        percent: smallCapValueFundData.sector_weightings[14].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[15].name,
        percent: smallCapValueFundData.sector_weightings[15].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[16].name,
        percent: smallCapValueFundData.sector_weightings[16].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[17].name,
        percent: smallCapValueFundData.sector_weightings[17].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[18].name,
        percent: smallCapValueFundData.sector_weightings[18].percent,
      },
      {
        name: smallCapValueFundData.sector_weightings[19].name,
        percent: smallCapValueFundData.sector_weightings[19].percent,
      },
    ],
  },
  // //////////////////////////////////////////////////////
};
export default fundData;

